/* eslint-disable guard-for-in */
/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable max-lines */
/* eslint-disable max-len */
import jsCookie from 'js-cookie';
import {v1 as uuid} from 'uuid';
import assert from 'assert';
import queryString from 'query-string';
import ServerBase from './server_base';
// import { WizServerError } from '../common/error';
import {MentionType} from '@/constants/document/mention';
import {logger, setLoggerUser} from '@/pages/searchPage/logger';
import {
    ObjectType,
    MemberSearchType,
    OwnerType,
    CreationReadType,
    PERSONAL_SHOW_REPOENTRY,
    IPersenalShowRepoEntry,
    ENVIRONMENT_LEVEL,
} from '@/Constant';
import {
    Record, UserDetail, SinglePersonData,
    Member, Share, WizRequestOptions, DepInfo, Recommend, Comment,
    Template, Tag, MemberOperateType, Follow, SearchParams,
    IRecentlyListParams,
    ICommonUseKnowledge,
    ITableData,
    SearchParamsFromSearchPage,
    IHasFollowStarParams,
    IFollowStarParams,
    IUnFollowStarParams,
    SelectDropMenu,
    IPublishListData,
    IRecommednFeedAction,
} from '@/interface';
import {
    COMMON_USE_KNOWLEDGE_TYPE,
    SELECT_DROPMENU,
    HOMEPAGE_TAG,
} from '@/constants/home';
import routers, {ServerConfig, buildPath, tocRouters} from '../../config/routers';
import * as store from '../../store';
import {getMessagesObject, toMessage} from './utils';
import {getCurPathWithoutTicket, isInKuShare} from '../../utils/urlUtils';
import {fixRepositoryName} from '@/domains/space/Repository/Utils/fixRepositoryNameWithPersonal';
import {get, method} from 'lodash-es';
import {downloadToData, weirwoodApiLog} from '../common/request';
import dayjs from 'dayjs';
import eventBus, {GET_USER_INFO_SUCCESS} from '@/eventBus';
import * as storageUtils from '@/utils/storageUtils';
import {DataSheetTokenStorageKey} from '@/constants/document/doc';
import {addUuapJumpNum, isUuapJumpToMuch} from '@/utils/uuapTryLimit';
import {ErrorCode, SuccessCode} from '../common/error';
import {stringify} from '@/utils/kuQuery';
import {ILike, IRefer} from '@/plugins/QuestionAnswerPlugin/components/QACenter/interface';
import {makeUpSettings} from '@/utils/defaultSettings';
import history from '@/browserHistory';

const isSdkPage = (window as any).isSdkPage;

// let lastId = DefaultStart;
// const mockServer = 'https://yapi.baidu-int.com/mock/13783';
class AccountServer extends ServerBase {
    // server: string = 'http://zhoumengqi01.bcc-bdbl.baidu.com:8060/wiki/as';
    server: string = ServerConfig.as;
    tocServer: string = ServerConfig.toc;
    // MOCK地址联调后需改为对应服务地址
    mockBaseUrl?: string;
    mockBaseUrlKu?: string;
    user?: User;

    userRepository?: Repository;

    userGroup?: Department;

    rteGrayRepo: Array<Repository['repositoryGuid']> = [];
    // -1: waiting; 1: loading;
    userInfoGuidPool: Map<string, -1 | 1>;

    userDetailTimer = 0;

    constructor() {
        super('wikiToken');
        this.userInfoGuidPool = new Map<string, -1 | 1>();
        this.mockBaseUrl = 'https://yapi.baidu-int.com/mock/13783/as';
        this.mockBaseUrlKu = 'https://yapi.baidu-int.com/mock/13783/wiki/ku';
    }

    async updateUserGroupInfo() {
        const appId = (window as any).sdkToken || '';
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/open/check`,
                    noRetry: true,
                    appId: isSdkPage ? `${appId}` : undefined,
                }
            )
        );
        this.userGroup = result.group;
    }

    jumpUuap(ticket: string, options: WizRequestOptions = {}) {
        const isTocPage = window.isTocPage;
        // 对外知识库直接跳转登陆页
        if (isTocPage) {
            // mvp版本先统一跳转passport登陆页
            const url = buildPath(tocRouters.Login.path, {});
            const redirectUrl = `${url}?redirect=${encodeURIComponent(window.location.href)}`;
            history.replace(redirectUrl);
            return;
        }

        // 对内知识库跳uuap鉴权
        const loginUrl = process.env.REACT_APP_LOGIN_SERVER || '';
        const appKey = process.env.REACT_APP_LOGIN_APPKEY || '';
        const curOrigin = window.location.origin;
        const curPath = getCurPathWithoutTicket();
        const service = `${curOrigin}${curPath}`;
        const version = 'v2';
        const loginParams: {
            [key: string]: boolean | string;
        } = {
            service,
        };
        // @dst-todo 缓存逻辑暂时注释，后续再做优化
        // storageUtils.remove(DataSheetTokenStorageKey); // 跳转 uuap 时主动清除数据表 token
        if (ticket && !isInKuShare()) { // ku享自动登录不带renew，带renew会跳到手动登录
            loginParams.renew = true;
        }
        loginParams.appKey = appKey;
        loginParams.version = version;
        const url = options.uuapJumpUrl || `${loginUrl}?${stringify(loginParams)}`;
        console.log('日志：跳转到uuap, url: ---------------------------', url);
        window.location.replace(url);
    }

    updateUserInfo = (result: any) => {
        result.user.token = result.token;
        if (!result.user?.settings) {
            result.user.settings = {};
        }
        result.user.settings = makeUpSettings(result.user.settings);

        this.user = result.user;
        logger.init();
        this.user?.userGuid && setLoggerUser(this.user?.userGuid);
        this.userGroup = result.group;
        // 兼容新老接口
        this.userRepository = result.userRepository || result.repository || {};
        fixRepositoryName(this.userRepository as Repository);
        this.rteGrayRepo = get(result, 'wikiSettings.rte.gray', []) || [];

        // 触发事件
        eventBus.emit(GET_USER_INFO_SUCCESS);
    };

    loginWithAuth = async (ticket: string, options: WizRequestOptions = {}) => {
        try {
            const appId = (window as any).sdkToken || '';
            const isTocPage = window.isTocPage;
            const url = isTocPage ? `${this.tocServer}/login/auth?stoken=${ticket}` : `${this.server}/open/auth?ticket=${ticket}`;
            const result = await this.request(
                Object.assign(
                    {
                        method: 'post',
                        url,
                        noRetry: true,
                        appId: (isSdkPage && !isTocPage) ? `${appId}` : undefined,
                    },
                    options
                )
            );
            return result;
        } catch (err: any) {
            if (err.code === 12001) {
                import('@/components/Toast').then(module => {
                    module.default({
                        content: '检测到您未绑定邮箱，暂时无法使用知识库。若有问题请联系 v_lixue13@baidu.com',
                        type: module.ToastType.Error,
                        duration: -1,
                    });
                });
                return null;
            }
            if (err.code === 301) {
                options.beforeJump && options.beforeJump();
                if (isUuapJumpToMuch() && !window.isTocPage) {
                    console.error('uuap 跳转次数过多');
                    console.log('日志：uuap 跳转次数过多----------------');
                } else {
                    addUuapJumpNum();
                    console.log('日志：auth接口301，触发uuap跳转----------------', ticket);
                    this.jumpUuap(ticket);
                    return null;
                }
            }
            if (err.code === ErrorCode.userForbidden) {
                const path = buildPath(routers.Forbidden.path, {});
                location.href = path;
            }
            if (err.code === ErrorCode.tocUserUnauthorized) {
                const path = buildPath(tocRouters.Unauthorized.path, {});
                location.href = path;
            }
            throw err;
        }
    };

    // eslint-disable-next-line max-statements
    async autoLogin(ticket: string, options: WizRequestOptions = {}) {
        if (!options.noCheckExists) {
            assert(!this.user, 'User has already logged in');
        }
        if (options.onlyRefreshToken) {
            console.log('日志：autoLogin onlyRefreshToken，触发uuap跳转----------------', ticket);
            this.jumpUuap(ticket, options);
            return {};
        }
        try {
            const appId = (window as any).sdkToken || '';
            const isTocPage = window.isTocPage;
            const url = isTocPage ? `${this.tocServer}/login/check` : `${this.server}/open/check`;
            const result = await this.request(
                Object.assign(
                    {
                        method: 'get',
                        url,
                        noRetry: true,
                        appId: (isSdkPage && !isTocPage) ? `${appId}` : undefined,
                    },
                    options
                )
            );
            this.updateUserInfo(result);
            return result.user;
        } catch (err: any) {
            console.log('日志：autoLogin---check接口失败, 触发loginWithAuth: ----------------', ticket, window.location.href);
            if (err.code === ErrorCode.userForbidden) {
                const path = buildPath(routers.Forbidden.path, {});
                location.href = path;
                return;
            }
            if (err.code === ErrorCode.tocUserUnauthorized) {
                const path = buildPath(tocRouters.Unauthorized.path, {});
                location.href = path;
                return;
            }
            const result = await this.loginWithAuth(ticket, options);
            if (result) {
                this.updateUserInfo(result);
                return result.user;
            }
            return null;
        }
    }

    //
    get currentUser() {
        assert(this.user, 'User has not logged in');
        return this.user;
    }

    get requestOptions(): WizRequestOptions {
        if ((window as any).isSdkPage) {
            const appId = (window as any).sdkToken || '';
            return {
                wikiToken: `${this.user?.token}`,
                appId: `${appId}`,
            };
        }
        return {wikiToken: this.user?.token};
    }

    onTokenUpdated(token: string) {
        assert(token);
    }

    //
    getLogoUploadUrl(repository: Repository) {
        assert(repository, 'repository is null');
        // eslint-disable-next-line max-len
        return `${this.server}/spaces/${repository.spaceGuid}/groups/${repository.groupGuid}/repositories/${repository.repositoryGuid}/resources/avatar`;
    }

    getCoverUploadUrl(repository: Repository, uploadTime?: number) {
        assert(repository);
        let url = `${this.server}/spaces/${repository.spaceGuid}/groups/${repository.groupGuid}/repositories/${repository.repositoryGuid}/resources/cover`;
        if (uploadTime) {
            url += `?${uploadTime}`;
        }
        return url;
    }

    getDepLogoUploadUrl(spaceGuid: string, groupGuid: string, refresh?: number) {
        if (!spaceGuid || !groupGuid) {
            return '';
        }
        // eslint-disable-next-line max-len
        return `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/resources/avatar?t=${refresh || +new Date()}`;
    }

    getDepCoverUploadUrl(spaceGuid: string, groupGuid: string, refresh?: number) {
        if (!spaceGuid || !groupGuid) {
            return '';
        }
        return `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/resources/cover?t=${refresh || +new Date()}`;
    }

    addUserInfoPool(userGuid: string, showAchieve?: boolean) {
        const status = this.userInfoGuidPool.get(userGuid);
        if (!status) {
            this.userInfoGuidPool.set(userGuid, -1);
        }
        if (this.userDetailTimer) {
            window.clearTimeout(this.userDetailTimer);
        }
        this.userDetailTimer = window.setTimeout(() => {
            const userGuids: string[] = [];
            this.userInfoGuidPool.forEach((value, key) => {
                if (value < 0) {
                    this.userInfoGuidPool.set(key, 1);
                    userGuids.push(key);
                }
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.getUserInfoList(userGuids, showAchieve);
        }, 100);
    }

    // 使用get方法获取用户信息
    // 问题是当userGuids长度太大的时候会导致query参数过大导致请求失败
    // 现在暂时不用这个接口了，换成了post接口
    async getUserInfoListByGet(userGuids: string[]) {
        if (userGuids.length === 0) {
            return [];
        }
        //
        const options = this.requestOptions;
        const isTocPage = window.isTocPage;
        const url = isTocPage ? `${ServerConfig.toc}/users` : `${ServerConfig.ku}/users`;
        const result: User[] = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url,
                    params: {
                        userGuids: userGuids.join(','),
                    },
                },
                options
            )
        );
        return result;
    }

    // 使用post方法获取用户信息
    async getUserInfoList(userGuids: string[], showAchieve?: boolean) {
        if (userGuids.length === 0) {
            return [];
        }
        //
        const options = this.requestOptions;
        const isTocPage = window.isTocPage;
        const url = isTocPage ? `${ServerConfig.toc}/users` : `${ServerConfig.ku}/users`;
        const result: User[] = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url,
                    data: {
                        userGuids: userGuids,
                        // @todo 需要根据是否是小流量来传
                        showAchieve: !!showAchieve,
                    },
                },
                options
            )
        );

        // result.forEach(user => {
        //     store.setUserInfo(user);
        // });
        store.setUserInfoBatch(result, showAchieve);

        userGuids.forEach(guid => {
            this.userInfoGuidPool.delete(guid);
        });

        return result;
    }

    // 使用post方法获取顶栏用户信息
    async getHeadUserInfoList(userGuids: string[]) {
        if (userGuids.length === 0) {
            return [];
        }
        const options = this.requestOptions;
        const isTocPage = window.isTocPage;
        const url = isTocPage ? `${ServerConfig.toc}/users` : `${ServerConfig.ku}/users`;
        const result: User[] = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url,
                    data: {
                        userGuids: userGuids,
                    },
                },
                options
            )
        );
        return result;
    }

    getUserInfo(userGuid: string | null, showAchieve?: boolean) {
        const guid = userGuid || this.user?.userGuid || '';
        const detail = store.getUserInfo(guid);
        const isMatch = !showAchieve || detail?.showAchieve;
        // 如果需要获取成就信息 但是缓存数据中没有请求过 则重新请求
        if (detail && isMatch) {
            return detail;
        }
        this.addUserInfoPool(guid, showAchieve);
        return null;
    }

    async getUserDetailInfo(userGuid: string | null) {
        const guid = userGuid || this.user?.userGuid || '';
        const options = this.requestOptions;

        const isTocPage = window.isTocPage;
        const url = isTocPage ? `${this.tocServer}/users/${guid}` : `${this.server}/users/${guid}`;

        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url,
                },
                options
            )
        );

        const detail = result as UserDetail;
        return detail;
    }

    async getDocInfoById(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/doc/info`,
                    method: 'get',
                    params: {
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    getGrayReleaseData = async ({
        whiteKey,
    }: {
        whiteKey: string[];
    }) => {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/uniform/smallFlow/query`,
                    method: 'post',
                    data: {
                        businessKeys: whiteKey,
                    },
                },
                options
            )
        );
        return result;
    };

    async getCurTabMessages(pageSize: number, pageNumber: number, type: string | number, firstRequestTime: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/message/category/message`,
                    data: {
                        pageSize,
                        pageNum: pageNumber,
                        type,
                        queryDate: dayjs(firstRequestTime).format('YYYY-MM-DD HH:mm:ss'),
                        userGuid: this.user?.userGuid,
                    },
                },
                options
            )
        );
        const messages: {[index: string]: any} = {};
        Object.keys(result).forEach(item => {
            messages[item] = result[item].length ? getMessagesObject(result[item]) : [];
        });
        return messages;
    }

    async getMessageDetail(messageGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/messages/${messageGuid}`,
                    method: 'get',
                },
                options
            )
        );
        const message = toMessage(result);
        return message;
    }

    async putMessageRead(messageGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/message/${messageGuid}`,
                    method: 'put',
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async getUnReadMessageCount() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/message/category/statistics`,
                    method: 'post',
                    data: {
                        userGuid: this.user?.userGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    async putAllMessagesRead(type: string, firstRequestTime?: number) {
        const options = this.requestOptions;
        await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/message/category/read/status`,
                    method: 'put',
                    data: {
                        type,
                        queryDate: dayjs(firstRequestTime).format('YYYY-MM-DD HH:mm:ss'),
                        userGuid: this.user?.userGuid,
                    },
                },
                options
            )
        );
    }

    async deleteMessage(messageGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/message/${messageGuid}`,
                    method: 'delete',
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async getMembers(spaceGuid: string, groupGuid: string, repositoryGuid: string, pageSize: number, pageNum: number) {
        const options = this.requestOptions;
        const members = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/members?pageSize=${pageSize}&pageNum=${pageNum}`,
                    method: 'get',
                },
                options
            )
        );
        return members;
    }

    async getTodoMembers(spaceGuid: string, groupGuid: string, repositoryGuid: string) {
        const options = this.requestOptions;
        const members = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/members`,
                    method: 'get',
                    params: {
                        todo: true,
                    },
                },
                options
            )
        );
        return members;
    }

    async getMembersByRole(spaceGuid: string, groupGuid: string, repositoryGuid: string, roleName: string) {
        const options = this.requestOptions;
        const members = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/members`,
                    method: 'get',
                    params: {
                        roleName,
                    },
                },
                options
            )
        );
        return members;
    }

    async getMember(spaceGuid: string, groupGuid: string, repositoryGuid: string, memberGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    // eslint-disable-next-line max-len
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/members/${memberGuid}`,
                    method: 'get',
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async addMember(spaceGuid: string, groupGuid: string, repositoryGuid: string, member: Member, isSingle: boolean = false, receiverGuid: string = '') {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/members`,
                    method: 'post',
                    data: {
                        isSingle,
                        receiverGuid,
                        roleName: member.roleName,
                        action: member.action,
                        message: member.message,
                        members: [
                            {
                                memberGuid: member.memberGuid,
                                memberType: member.memberType,
                                nickname: member.nickname,
                                alias: member.alias,
                            },
                        ],
                    },
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async updateMember(spaceGuid: string, groupGuid: string, repositoryGuid: string, member: Member) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    // eslint-disable-next-line max-len
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/members/${member.memberGuid}`,
                    method: 'put',
                    data: member,
                },
                options
            )
        );
        // console.log(result);
        if (member.action === 'invite' || member.action === 'agree') {
            store.setMemberOperate({
                type: MemberOperateType.Add,
                repositoryGuid,
                time: Date.now(),
                memberGuid: [member.memberGuid],
                updateRoleName: member.roleName,
            });
        } else if (member.action === 'change') {
            store.setMemberOperate({
                type: MemberOperateType.Update,
                repositoryGuid,
                time: Date.now(),
                memberGuid: [member.memberGuid],
                updateRoleName: member.roleName,
            });
        }
        return result;
    }

    async deleteMember(spaceGuid: string, groupGuid: string, repositoryGuid: string, memberGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    // eslint-disable-next-line max-len
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/members/${memberGuid}`,
                    method: 'delete',
                    params: {
                        groupGuid,
                    },
                },
                options
            )
        );
        // console.log(result);
        store.setMemberOperate({
            type: MemberOperateType.Delete,
            repositoryGuid,
            time: Date.now(),
            memberGuid: [memberGuid],
        });
        return result;
    }

    async changeRepoUnowned(spaceGuid: string, groupGuid: string, repositoryGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/unowned`,
                    method: 'post',
                    data: {},
                },
                options
            )
        );
        return result;
    }

    async search(spaceGuid: string, q: string, type?: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/space/${spaceGuid}/search`,
                    method: 'get',
                    params: {
                        q,
                        type,
                    },
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async addShare(spaceGuid: string, groupGuid: string, repositoryGuid: string, docGuid: string | null, share: Share) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/shares`,
                    method: 'post',
                    params: {
                        groupGuid,
                        repositoryGuid,
                        docGuid,
                    },
                    data: share,
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async getShare(spaceGuid: string, groupGuid: string, repositoryGuid: string, docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/shares`,
                    method: 'get',
                    params: {
                        groupGuid,
                        repositoryGuid,
                        docGuid,
                    },
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async updateShare(spaceGuid: string, groupGuid: string, repositoryGuid: string, docGuid: string, share: Share) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/shares`,
                    method: 'put',
                    params: {
                        groupGuid,
                        repositoryGuid,
                        docGuid,
                    },
                    data: share,
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async deleteShare(spaceGuid: string, groupGuid: string, repositoryGuid: string, docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/shares`,
                    method: 'delete',
                    params: {
                        groupGuid,
                        repositoryGuid,
                        docGuid,
                    },
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async viewShare(
        spaceGuid: string,
        groupGuid: string,
        repositoryGuid: string,
        docGuid: string,
        shareGuid: string,
        share: Share
    ) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/shares/${shareGuid}`,
                    method: 'post',
                    params: {
                        groupGuid,
                        repositoryGuid,
                        docGuid,
                    },
                    data: share,
                },
                options
            )
        );
        // console.log(result);
        return result;
    }
    // follow user: userGuid
    // follow repository: spaceGuid, repositoryGuid
    // follow document: spaceGuid, repositoryGuid, docGuid
    // async followRepository(spaceGuid: string, repositoryGuid: string) {
    //     const options = this.requestOptions;
    //     const result = await this.request(
    //         Object.assign(
    //             {
    //                 url: `${this.server}/follows`,
    //                 method: 'post',
    //                 data: {
    //                     spaceGuid,
    //                     repositoryGuid,
    //                 },
    //             },
    //             options
    //         )
    //     );
    //     // console.log(result);
    //     return result;
    // }

    // async followGroup(spaceGuid: string, groupGuid: string) {
    //     const options = this.requestOptions;
    //     const result = await this.request(Object.assign({
    //         url: `${this.server}/follows`,
    //         method: 'post',
    //         data: {
    //             spaceGuid,
    //             groupGuid,
    //         },
    //     }, options));
    //     // console.log(result);
    //     return result;
    // }

    // 删除知识库
    async deleteGroup(spaceGuid: string, groupGuid: string, repositoryGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            url: `${this.server}/spaces/${spaceGuid}/recycle/groups/${groupGuid}/repositories/${repositoryGuid}`,
            method: 'delete',
        }, options));
        return result;
    }

    // 移动知识库
    async moveGroup(spaceGuid: string, groupGuid: string, repositoryGuid: string, message?: string) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}`,
            method: 'put',
            data: {
                move: {
                    action: 'out',
                    groupGuid: `${groupGuid}`,
                    message,
                    isAuto: true,
                },
            },
        }, options));
        return result;
    }

    // 置顶知识库
    async isTopGroup(path: {
        spaceGuid: string;
        groupGuid: string;
    }, data: {
        repoGuid: string;
        action: 1 | 2; // 1:置顶 2:取消置顶
    }) {
        const {
            spaceGuid,
            groupGuid,
        } = path;
        const {
            repoGuid,
            action,
        } = data;
        const result = await this.request(Object.assign({
            url: `${ServerConfig.ku}/space/${spaceGuid}/group/${groupGuid}/repository/top`,
            method: 'post',
            data: {
                repoGuid,
                action,
            },
        }, this.requestOptions));
        return result;
    }


    async moveInGroup(
        spaceGuid: string,
        groupGuid: string,
        repositoryGuid: string,
        selectedGroupGuid: string,
        message?: string
    ) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}`,
            method: 'put',
            data: {
                move: {
                    action: 'in',
                    groupGuid: `${selectedGroupGuid}`,
                    message,
                },
            },
        }, options));
        return result;
    }

    // async followDoc(spaceGuid: string, repositoryGuid: string, docGuid: string) {
    //     const options = this.requestOptions;
    //     const result = await this.request(
    //         Object.assign(
    //             {
    //                 url: `${this.server}/follows`,
    //                 method: 'post',
    //                 data: {
    //                     spaceGuid,
    //                     repositoryGuid,
    //                     docGuid,
    //                 },
    //             },
    //             options
    //         )
    //     );
    //     // console.log(result);
    //     return result;
    // }
    /*
        // MARKS: 星标接口统一
        星标类型
            user: userGuid
            department: type, spaceGuid, groupGuid
            repository: type, spaceGuid, groupGuid, repositoryGuid
            document: type, spaceGuid, groupGuid, repositoryGuid, docGuid

        接口interface参考
            interface IHasFollowStarParams{
                type: FollowType;
                spaceGuid?: string;
                groupGuid?: string;
                repositoryGuid?: string;
                docGuid?: string;
                userGuid?: string;
            }
            interface IFollowStarParams{
                type: FollowType;
                spaceGuid: string;
                groupGuid: string;
                repositoryGuid?: string;
                docGuid?: string;
                userGuid?: string;
            }
            interface IUnFollowStarParams{
                type: FollowType;
                followGuid: string;
                spaceGuid: string;
                groupGuid: string;
                repositoryGuid?: string;
                docGuid?: string;
            }
    */
    async hasFollowStar(params: IHasFollowStarParams) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/follow/confirm`,
                    method: 'get',
                    params,
                },
                options
            )
        );
        // console.log(result);
        return result;
    }
    async followStar(data: IFollowStarParams) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/follow/create`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        // console.log(result);
        return result;
    }
    async unFollowStar(data: IUnFollowStarParams) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/follow/cancel`,
                    method: 'delete',
                    data,
                },
                options
            )
        );
        // console.log(result);
        return result;
    }


    // async hasFollowedRepository(spaceGuid: string, repositoryGuid: string) {
    //     const options = this.requestOptions;
    //     const result = await this.request(
    //         Object.assign(
    //             {
    //                 url: `${this.server}/follows`,
    //                 method: 'get',
    //                 params: {
    //                     spaceGuid,
    //                     repositoryGuid,
    //                 },
    //             },
    //             options
    //         )
    //     );
    //     // console.log(result);
    //     return result;
    // }

    // async hasFollowedDoc(spaceGuid: string, repositoryGuid: string, docGuid: string) {
    //     const options = this.requestOptions;
    //     const result = await this.request(
    //         Object.assign(
    //             {
    //                 url: `${this.server}/follows`,
    //                 method: 'get',
    //                 params: {
    //                     spaceGuid,
    //                     repositoryGuid,
    //                     docGuid,
    //                 },
    //             },
    //             options
    //         )
    //     );
    //     // console.log(result);
    //     return result;
    // }

    // async hasFollowedDepartment(spaceGuid: string, groupGuid: string) {
    //     const options = this.requestOptions;
    //     const result = await this.request(Object.assign({
    //         url: `${this.server}/follows`,
    //         method: 'get',
    //         params: {
    //             spaceGuid,
    //             groupGuid,
    //         },
    //     }, options));
    //     return result;
    // }

    // async followDepartment(spaceGuid: string, groupGuid: string) {
    //     const options = this.requestOptions;
    //     const result = await this.request(Object.assign({
    //         url: `${this.server}/follows`,
    //         method: 'post',
    //         data: {
    //             spaceGuid,
    //             groupGuid,
    //         },
    //     }, options));
    //     return result;
    // }

    // async cancelDepartmentFollow(followGuid: string) {
    //     const options = this.requestOptions;
    //     const result = await this.request(Object.assign({
    //         url: `${this.server}/follows/${followGuid}?type=20`,
    //         method: 'delete',
    //     }, options));
    //     return result;
    // }

    // type='' return doc and repository
    async getUserFollows(
        userGuid: string,
        start: number,
        count: number,
        type: ObjectType.Doc | ObjectType.Repository | ''
    ) {
        const options = this.requestOptions;
        const result: Follow[] = await this.request(
            Object.assign(
                {
                    url:
                        `${ServerConfig.ku}/users/${userGuid || this.user?.userGuid
                        }/follows?start=${start}&count=${count}&type=${type}`,
                    method: 'get',
                },
                options
            )
        );
        result.forEach(item => {
            if (typeof item.json === 'string') {
                try {
                    item.json = JSON.parse(item.json);
                } catch (err) {
                    console.error(err);

                    item.json = {};
                }
            }

            if (item.json.data && item.json.data.repository) {
                const r: Repository = item.json.data.repository;
                fixRepositoryName(r);
                // json.data.repository 可能与 item.repositoryGuid 不一致，需要分别处理
                // 不一致且不为部门知识库时 肯定是 个人知识库
                const isRepositoryGuidSame = item.repositoryGuid === r.repositoryGuid;
                const isPersonalRepo = !isRepositoryGuidSame && item.json.type !== ObjectType.Group;
                const itemR: Repository = {
                    spaceGuid: item.spaceGuid,
                    groupGuid: item.groupGuid,
                    repositoryGuid: item.repositoryGuid,
                    ownerType: isPersonalRepo ? OwnerType.User : r.ownerType,
                    name: type === ObjectType.Doc ? item.repositoryName || '' : item.name,
                };
                fixRepositoryName(itemR);
                if (type === ObjectType.Doc) {
                    item.repositoryName = itemR.name || '';
                } else if (type === ObjectType.Repository) {
                    item.name = itemR.name || '';
                }
            }
        });
        return result;
    }

    // async unFollow(followGuid: string, type: number) {
    //     const options = this.requestOptions;
    //     const result = await this.request(
    //         Object.assign(
    //             {
    //                 url: `${this.server}/follows/${followGuid}`,
    //                 method: 'delete',
    //                 params: {
    //                     type,
    //                 },
    //             },
    //             options
    //         )
    //     );
    //     // console.log(result);
    //     return result;
    // }

    // async unFollowDepartment(followGuid: string) {
    //     const options = this.requestOptions;
    //     const result = await this.request(Object.assign({
    //         url: `${this.server}/follows/${followGuid}`,
    //         method: 'delete',
    //     }, options));
    //     // console.log(result);
    //     return result;
    // }

    // group
    //
    async createRepository(spaceGuid: string, groupGuid: string, repository: any) {
        //
        assert(spaceGuid, 'spaceGuid can not be null');
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories`,
                    data: repository,
                },
                options
            )
        );
        return result;
    }
    //
    async getRequestResult(requestGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/misc/requests/${requestGuid}`,
                },
                options
            )
        );
        return result;
    }
    //
    async deleteRepository(spaceGuid: string, groupGuid: string, repositoryGuid: string) {
        //
        assert(spaceGuid, 'spaceGuid can not be null');
        assert(groupGuid, 'groupGuid can not be null');
        assert(repositoryGuid);
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'delete',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}`,
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async applyDeleteRepository(spaceGuid: string, groupGuid: string, repositoryGuid: string, message: string) {
        //
        assert(spaceGuid, 'spaceGuid can not be null');
        assert(groupGuid, 'groupGuid can not be null');
        assert(repositoryGuid);
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'delete',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}`,
            data: {
                message,
            },
        }, options));
        // console.log(result);
        return result;
    }
    async recoverRepository(spaceGuid: string, groupGuid: string, repositoryGuid: string) {
        //
        assert(spaceGuid, 'spaceGuid can not be null');
        assert(groupGuid, 'groupGuid can not be null');
        assert(repositoryGuid);
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/recovery`,
                },
                options
            )
        );
        // console.log('recover group');
        // console.log(result);
        return result;
    }
    // repository
    //
    async getRepositoryByGuid(spaceGuid: string, groupGuid: string, repositoryGuid: string, docGuid?: string) {
        assert(spaceGuid, 'spaceGuid can not be null');
        assert(groupGuid, 'groupGuid can not be null');
        assert(repositoryGuid, 'repositoryGuid can not be null');
        const options = this.requestOptions;
        const result: Repository = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/space/groups/repositories/info`,
                    params: {
                        spaceGuid,
                        groupGuid,
                        repositoryGuid,
                        docGuid,
                    },
                    returnFullError: true,
                },
                options
            )
        );
        fixRepositoryName(result);
        return result;
    }
    async getRepositoryByGuidNoFixName(spaceGuid: string, groupGuid: string, repositoryGuid: string, docGuid?: string) {
        assert(spaceGuid, 'spaceGuid can not be null');
        assert(groupGuid, 'groupGuid can not be null');
        assert(repositoryGuid, 'repositoryGuid can not be null');
        const options = this.requestOptions;
        const result: Repository = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/space/groups/repositories/info`,
                    params: {
                        spaceGuid,
                        groupGuid,
                        repositoryGuid,
                        docGuid,
                    },
                    returnFullError: true,
                },
                options
            )
        );
        return result;
    }

    async getRepositoryServerUrl(spaceGuid: string, groupGuid: string, repositoryGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/serverUrl`,
                },
                options
            )
        );
        return result;
    }
    //
    async checkRepositoryName(spaceGuid: string, groupGuid: string, name: string) {
        //
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/check`,
                    data: {name},
                },
                options
            )
        );
        return result;
    }

    //
    async updateRepository(repository: Repository) {
        //
        const options = this.requestOptions;
        delete repository.invitation;
        const result = await this.request(
            Object.assign(
                {
                    method: 'put',
                    // eslint-disable-next-line max-len
                    url: `${this.server}/spaces/${repository.spaceGuid}/groups/${repository.groupGuid}/repositories/${repository.repositoryGuid}`,
                    data: repository,
                },
                options
            )
        );
        // console.log('update repositories');
        // console.log(result);
        return result;
    }
    //
    async uploadRepositoryLOGO(spaceGuid: string, groupGuid: string, repositoryGuid: string, file: any) {
        //
        const options = this.requestOptions;
        const formData = new FormData();
        formData.append('filename', file.name);
        formData.append('file', file);
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/resources\
/avatar`,
                    data: formData,
                    headers: {
                        'content-type': 'multipart/form-data',
                    },
                },
                options
            )
        );
        // console.log(result);
        return result;
    }
    async uploadRepositoryCover(repository: Repository, file: any) {
        //
        const {spaceGuid, groupGuid, repositoryGuid} = repository;
        const options = this.requestOptions;
        const formData = new FormData();
        formData.append('filename', file.name);
        formData.append('file', file);
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/resources/cover`,
                    data: formData,
                    headers: {
                        'content-type': 'multipart/form-data',
                    },
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async uploadDepLOGO(spaceGuid: string, groupGuid: string, file: any) {
        //
        const options = this.requestOptions;
        const formData = new FormData();
        formData.append('filename', file.name);
        formData.append('file', file);
        const result = await this.request(Object.assign({
            method: 'post',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/resources/avatar`,
            data: formData,
            headers: {
                'content-type': 'multipart/form-data',
            },
        }, options));
        // console.log(result);
        return result;
    }
    async uploadDepCover(spaceGuid: string, groupGuid: string, file: any) {
        //
        const options = this.requestOptions;
        const formData = new FormData();
        formData.append('filename', file.name);
        formData.append('file', file);
        const result = await this.request(Object.assign({
            method: 'post',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/resources/cover`,
            data: formData,
            headers: {
                'content-type': 'multipart/form-data',
            },
        }, options));
        // console.log(result);
        return result;
    }

    // 通用上传图片或文件
    async uploadImageFile(file: any) {
        const options = this.requestOptions;
        const formData = new FormData();
        formData.append('name', file.name);
        formData.append('file', file);
        const result = await this.request(Object.assign({
            method: 'post',
            url: `${ServerConfig.wiki}/attach/open/upload`,
            data: formData,
            headers: {
                'content-type': 'multipart/form-data',
            },
        }, options));
        return result;
    }

    //
    async getWikiAccessToken(spaceGuid: string, groupGuid: string, repositoryGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/space/groups/repositories/accessTokens`,
                    data: {
                        spaceGuid,
                        groupGuid,
                        repositoryGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    async getUgateToken(target: string, source: string) {
        try {
            const result = await this.request(
                Object.assign(
                    {
                        method: 'get',
                        url: `${ServerConfig.ku}/ugate/token`,
                        params: {
                            target,
                        },
                    }
                )
            );
            return result;
        } catch (error) {
            console.error(`获取 ugate token 失败: ${target}-${source === 'init' ? 'init' : 'sdk'}`, error);
            throw error;
        }
    }

    async getTDAUgateToken(ak: string) {
        try {
            const requestOptions = Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/ugate/v2/token`,
                    params: {
                        ak,
                    },
                },
                {
                    ignoreUgateTokenInvalid: true,
                }
            );
            const result = await this.request(
                Object.assign(requestOptions)
            );
            return result;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    //
    async getRepositoryLogs(
        spaceGuid: string,
        groupGuid: string,
        repositoryGuid: string,
        pageSize: number,
        pageNum: number,
        ascending: 'desc' | 'asc'
    ) {
        //
        assert(spaceGuid, 'spaceGuid can not be null');
        assert(groupGuid, 'groupGuid can not be null');
        assert(repositoryGuid, 'repositoryGuid can not be null');
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/logs?pageSize=${pageSize}&pageNum=${pageNum}&ascending=${ascending}`,
                },
                options
            )
        );
        return result;
    }

    async getUserRepositories(spaceGuid: string) {
        //
        assert(this.user);
        const options = this.requestOptions;
        const result: Repository[] = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/users/${this.user.userGuid}/repositories`,
                    params: {
                        spaceGuid,
                    },
                },
                options
            )
        );
        result.forEach(item => {
            fixRepositoryName(item);
        });
        return result;
    }

    // 获取知识库列表
    // async getListRepositories(
    //     spaceGuid: string,
    //     groupGuid: string,
    //     pageSize: number,
    //     pageNum: number,
    //     sortType: 'desc' | 'asc'
    // ) {
    //     const options = this.requestOptions;
    //     const result = await this.request(Object.assign({
    //         method: 'get',
    //         url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories?pageSize=${pageSize}&pageNum=${pageNum}&ascending=${sortType}`,
    //     }, options));
    //     return result;
    // }

    async getListRepositories(
        params: {
            spaceGuid: string;
            groupGuid: string;
            pageSize: number;
            pageNum: number;
            orderBy: string;
            ascending: string;
            keyword?: string;
        }
    ) {
        const {spaceGuid, groupGuid, ...restParams} = params;
        const options = this.requestOptions;
        if (restParams.keyword === '') {
            delete restParams.keyword;
        }
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories`,
            params: {
                ...restParams,
            },
        }, options));
        return result;
    }

    // 获取团队信息
    async getGroup(spaceGuid: string, groupGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}`,
        }, options));
        return result;
    }

    async getUserLogs(userGuid: string, start: number, count: number) {
        //
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/users/${userGuid || this.user?.userGuid}/logs?start=${start}&count=${count}`,
        }, options));
        return result;
    }

    async getUserRecords(userGuid?: string | null) {
        const options = this.requestOptions;
        const result: Record[] = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/users/${userGuid || this.user?.userGuid}/records`,
                    method: 'get',
                },
                options
            )
        );
        result.forEach(item => {
            if (item.objectType === ObjectType.Repository) {
                const r: Repository = {
                    repositoryGuid: item.repositoryGuid,
                    spaceGuid: item.spaceGuid,
                    groupGuid: item.groupGuid,
                    ownerType: item.ownerType,
                    name: item.name,
                };
                fixRepositoryName(r);
                item.name = r.name || '';
            }
        });
        return result;
    }

    async getUserKnowledgeTags(email?: string) {
        assert(this.user && this.user.email);

        email = email || this.user.email;
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            url: `${this.server}/rl/knowledge/tags`,
            method: 'get',
            params: {
                email,
            },
        }, options));
        const tags: Tag[] = result[`${email}`].map((item: {[key: string]: any}) => {
            const tag: Tag = {
                source: item.source,
                score: item.score,
                value: item['@value'],
                type: item.type,
            };
            return tag;
        });
        // console.log(tags);
        return tags;
    }

    async getRepositoryTemplates() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/templates/repo`,
                },
                options
            )
        );
        return result;
    }

    // eslint-disable-next-line max-params
    async getDocTemplates(
        spaceGuid: string,
        groupGuid: string,
        repositoryGuid: string,
        xWikiAccess: string,
        parentGuid: string,
        start: number = 0,
        count: number = 20,
        withSystem: boolean = false
    ) {
        //
        assert(spaceGuid, 'spaceGuid can not be null');
        assert(groupGuid, 'groupGuid can not be null');
        assert(repositoryGuid, 'repositoryGuid can not be null');
        const options = this.requestOptions;
        const parentObj = parentGuid ? {parentGuid} : {};
        const search = queryString.stringify({
            ...{
                start,
                count,
                withSystem,
            },
            ...parentObj,
        });
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/templates?${search}`,
                },
                {...options, wikiAccessToken: xWikiAccess}
            )
        );
        // console.log(result);
        return result;
    }

    async deleteRepositoryTemplate(spaceGuid: string, groupGuid: string, repositoryGuid: string, templateId: number) {
        //
        assert(spaceGuid, 'spaceGuid can not be null');
        assert(groupGuid, 'groupGuid can not be null');
        assert(repositoryGuid, 'repositoryGuid can not be null');
        const options = this.requestOptions;
        // console.log(`${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}
        // /templates/${templateId}`);
        const result = await this.request(
            Object.assign(
                {
                    method: 'delete',
                    // eslint-disable-next-line max-len
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/templates/${templateId}`,
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async createRepositoryTemplate(
        spaceGuid: string,
        groupGuid: string,
        repositoryGuid: string,
        templateInfo: Template
    ) {
        //
        assert(spaceGuid, 'spaceGuid can not be null');
        assert(groupGuid, 'groupGuid can not be null');
        assert(repositoryGuid, 'repositoryGuid can not be null');
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/templates`,
                    data: templateInfo,
                },
                options
            )
        );
        // console.log(result);
        return result;
    }

    async getSearchPerson(params: string, type: MemberSearchType | string, querySensitiveUser?: boolean, queryExternalUser?: boolean) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/open/users?q=${params}${type ? `&t=${type}` : ''}&querySensitiveUser=${querySensitiveUser}&queryExternalUser=${queryExternalUser}`,
                    method: 'get',
                },
                options
            )
        );
        return {result: result, query: params};
    }

    async getSearchVirtual(params: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/virtual/user/${params}`,
                    method: 'get',
                },
                options
            )
        );
        return {result: result};
    }

    async addPerson(repository?: Repository, params?: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.server}/spaces/${repository?.spaceGuid}/groups/${repository?.groupGuid}/repositories/${repository?.repositoryGuid}/members`,
                    data: params,
                },
                options
            )
        );
        if (params.action === 'invite' || params.action === 'agree') {
            store.setMemberOperate({
                type: MemberOperateType.Add,
                repositoryGuid: repository?.repositoryGuid || '',
                time: Date.now(),
                memberGuid: params?.members ? params.members.map((item:any) => item.memberGuid) : [],
                updateRoleName: params.roleName,
            });
        }
        return result;
    }

    async getIdentityPersonList(repository?: Repository, params: any = '') {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url:
                        `${this.server}/spaces/${repository?.spaceGuid}/groups/${repository?.groupGuid}/repositories/${repository?.repositoryGuid
                        }/members${params ? `?memberGuids=${params}` : ''}`,
                },
                options
            )
        );
        return result;
    }

    async getMemberInfo(params: string = '') {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/users${params ? `?userGuids=${params}` : ''}`,
                },
                options
            )
        );
        return result;
    }

    async share(params: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.server}/shares`,
                    data: params,
                },
                options
            )
        );
        return result;
    }

    // 获取默认设置的数据
    async getSettingDefault(user: User) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/users/${user.userGuid}/settings`,
                },
                options
            )
        );
        return result;
    }

    async updateUser(user: User) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'put',
                    url: `${this.server}/users/${user.userGuid}`,
                    data: {settings: user.settings},
                },
                options
            )
        );

        return result;
    }

    updateNewGuide = async (data: User['settings']['newGuide']) => {
        const user = this.user as User;
        const settings = user
            ? user.settings
            : {
                newGuide: {},
            };
        const {newGuide = {}} = settings;
        user.settings.newGuide = {
            ...newGuide,
            ...data,
        };
        await this.updateUser(user);
    };

    async userLogOut() {
        const options = this.requestOptions;
        const isTocPage = window.isTocPage;
        const reqUrl = isTocPage ? `${this.tocServer}/logout` : `${this.server}/open/logout`;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: reqUrl,
                },
                options
            )
        );

        if (isTocPage) {
            // 对外知识库，跳转passport地址清空登录状态
            const redirectUrl = encodeURIComponent(window.location.origin + tocRouters.Login.path);
            const passportUrlMap = {
                online: 'https://passport.baidu.com',
                test: 'https://passport.qatest.baidu.com',
            };
            const isOnline = [
                ENVIRONMENT_LEVEL.online,
                ENVIRONMENT_LEVEL.gray,
            ].includes(process.env.REACT_APP_ENVIRONMENT || '');
            const passportUrl = isOnline ? passportUrlMap.online : passportUrlMap.test;
            window.location.href = `${passportUrl}/?logout&u=${redirectUrl}`;
        } else {
            // 对内知识库，跳转uuap地址清空登录状态
            const loginUrl = process.env.REACT_APP_LOGIN_SERVER || '';
            const appKey = process.env.REACT_APP_LOGIN_APPKEY || '';
            const host = window.location.host;
            const protocol = window.location.protocol;
            const service = `${protocol}//${host}`;
            const loginParams = {
                service,
                appKey,
            };
            const url = `${loginUrl}/logout?${stringify(loginParams)}`;
            window.location.href = url;
        }
        return result;
    }

    // department   sdk
    // 部门 获取审批列表
    async getApprovalList(spaceGuid: string, groupGuid: string, pageNum: number, pageSize: number) {
        const options = this.requestOptions;
        const search = queryString.stringify({
            pageNum,
            pageSize,
        });
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/approvals?${search}`,
                },
                options
            )
        );
        return result;
    }

    // 部门 审批-同意
    async getApprovalAgree(spaceGuid: string, groupGuid: string, approvalId: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/approvals/${approvalId}/agree`,
                },
                options
            )
        );
        return result;
    }

    // 部门 审批-拒绝
    async getApprovalDisAgree(spaceGuid: string, groupGuid: string, approvalId: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/approvals/${approvalId}/disagree`,
                },
                options
            )
        );
        return result;
    }

    // 部门 审批-修改
    async putApproval(spaceGuid: string, groupGuid: string, approvalId: string, roleName: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'put',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/approvals/${approvalId}`,
                    data: {
                        roleName,
                    },
                },
                options
            )
        );
        return result;
    }

    // 部门层面 获取回收站知识库列表
    async getRecycleBinKnowledge(spaceGuid: string, groupGuid: string, pageNum: number, pageSize: number) {
        const options = this.requestOptions;
        const search = queryString.stringify({
            pageNum,
            pageSize,
        });
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/spaces/${spaceGuid}/recycle/groups/${groupGuid}/repositories?${search}`,
                },
                options
            )
        );
        return result;
    }

    // 部门层面 彻底删除知识库
    async deleteKnowledge(spaceGuid: string, groupGuid: string, repositoryGuids: string[]) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'delete',
                    url: `${this.server}/spaces/${spaceGuid}/recycle/groups/${groupGuid}/repositories`,
                    data: {
                        repositoryGuids,
                    },
                },
                options
            )
        );
        return result;
    }

    // 部门层面 恢复知识库
    async recoverKnowledge(spaceGuid: string, groupGuid: string, repositoryGuids: string[]) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.server}/spaces/${spaceGuid}/recycle/groups/${groupGuid}/repositories`,
                    data: {
                        repositoryGuids,
                    },
                },
                options
            )
        );
        return result;
    }

    // 部门层面 获取操作日志
    async getOperationLog(spaceGuid: string, groupGuid: string, pageSize: number, pageNum: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/logs`,
                    params: {
                        pageNum,
                        pageSize,
                    },
                },
                options
            )
        );
        return result;
    }
    // 【部门】获取部门团队信息
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getDepInfo(spaceGuid: string, groupGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}`,
                },
                options
            )
        );
        return result;
    }

    // 【部门】修改团队简介，公告，标签,安全设置
    async updateDepInfo(spaceGuid: string, groupGuid: string, depInfo: DepInfo) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'put',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}`,
                    data: depInfo,
                },
                options
            )
        );
        return result;
    }

    // 【部门】获取管理员推荐列表
    async getRecommends(spaceGuid: string, groupGuid: string, pageNum: number, pageSize: number) {
        const options = this.requestOptions;
        const search = queryString.stringify({
            pageNum,
            pageSize,
        });
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/recommends?${search}`,
                },
                options
            )
        );
        return result;
    }

    // 【部门】新建管理员推荐列表
    async addRecommends(spaceGuid: string, groupGuid: string, recommends: Recommend[]) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/recommends`,
                    data: {
                        recommends,
                    },
                },
                options
            )
        );
        return result;
    }

    // 【部门】删除管理员推荐列表
    async deleteRecommends(spaceGuid: string, groupGuid: string, objectId: string[]) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'delete',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/recommends/${objectId.join(',')}`,
                },
                options
            )
        );
        return result;
    }

    // 【部门】置顶/取消置顶 管理员推荐列表
    async arrangeTopRecommends(spaceGuid: string, groupGuid: string, objectId: string[], top: boolean) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'put',
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/recommends/${objectId.join(',')}`,
                    data: {
                        top: top ? 1 : 0,
                    },
                },
                options
            )
        );
        return result;
    }

    // 【部门】获取热门知识库
    async getActiveRepos(spaceGuid: string, groupGuid: string, query?: any) {
        const options = this.requestOptions;
        const params = query
            ? {
                ...query,
            }
            : {};
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/active-repos`,
            params,
        }, options));
        return result;
    }

    // 【部门】获取活跃成员
    async getActiveMembers(spaceGuid: string, groupGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/active-members`,
        }, options));
        return result;
    }

    // 评论
    async articleComments(spaceGuid: string, groupGuid: string, comment: Comment) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/comments`,
                    method: 'post',
                    data: comment,
                },
                options
            )
        );
        return result;
    }
    // 获取评论列表
    async getCommentsList(spaceGuid: string, groupGuid: string, pageSize: number, pageNum: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/comments`,
                    method: 'get',
                    params: {
                        pageNum,
                        pageSize,
                    },
                },
                options
            )
        );
        return result;
    }

    // 删除评论
    async deleteComment(spaceGuid: string, groupGuid: string, commentGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/comments/${commentGuid}`,
                    method: 'delete',
                },
                options
            )
        );
        return result;
    }

    // 【部门】获取成员动态
    async getDepartmentMemberLogs(spaceGuid: string, groupGuid: string, pageNum: number, pageSize: number) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/memberLogs`,
            params: {
                pageNum,
                pageSize,
            },
        }, options));
        return result;
    }

    // 【部门】 获取用户团队列表
    async getDepartments(spaceGuid: string, groupGuid?: string, query?: string) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/spaces/${spaceGuid}/groups`,
            params: {
                keyword: query,
                groupGuid,
            },
        }, options));
        return result;
    }

    // 【部门】 获取用户知识库列表
    async getDepartmentRepos(spaceGuid: string, groupGuid: string, query: string) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories`,
            params: {
                keyword: query,
                pageNum: 1,
                pageSize: 50,
                ascending: 'desc',
                scope: 'space',
            },
        }, options));
        return result;
    }

    // 【部门】获取编辑部门详情详细简介rte token
    async getIntroDetailToken(spaceGuid: string, groupGuid: string, docType: string, timeout: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign({
                url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/rte/${docType}/tokens`,
                method: 'post',
            }, {
                ...options,
                timeout,
            })
        );
        return result;
    }

    async getIntroDetailTokenOld(spaceGuid: string, groupGuid: string, docType: string, sToken: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign({
                url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/rte/${docType}/tokens`,
                method: 'post',
            }, {
                ...options,
                xWikiRteSToken: sToken,
            })
        );
        return result;
    }

    // 获取知识库grouopGuid
    async getRepoGroupId(spaceGuid: string, repositoryGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/spaces/${spaceGuid}/repositories/${repositoryGuid}`,
        }, options));
        return result;
    }

    async saveIntroDetail(spaceGuid: string, groupGuid: string, docType: string, mentions: any[]) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign({
                url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/rte/${docType}/save`,
                data: {
                    mentions,
                },
                method: 'put',
            }, options)
        );
        return result;
    }

    async shareDepartment(spaceGuid: string, groupGuid: string, users: SinglePersonData[], thumb: string, url: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign({
                url: `${this.server}/shares`,
                method: 'post',
                data: {
                    url: `${url}?source=1`,
                    spaceGuid,
                    groupGuid,
                    users,
                    thumb,
                },
            }, options)
        );
        return result;
    }
    // 获取个人是管理员的所有知识库
    async getRepositoriesByUserGuid(userGuid: string, params: {
        pageNum: number;
        pageSize: number;
        groupGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/users/${userGuid}/manageRepos`,
            params: {
                ...params,
            },
        }, options));
        return result;
    }

    // 批量移动知识库到部门内
    async moveRepositoriesToDepartment(
        spaceGuid: string,
        groupGuid: string,
        data: {
            repoList: string[];
        }) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'post',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/moveIn`,
            data,
        }, options));
        return result;
    }

    // 修改部门知识库成员权限
    async editorDepartmentMemberRole(data: {
        action?: 'change';
        roleName?: string;
        alias?: string;
    }, otherParams: {memberGuid: string, groupGuid: string, spaceGuid: string}) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'PUT',
            url: `${this.server}/spaces/${otherParams.spaceGuid}/groups/${otherParams.groupGuid}/members/${otherParams.memberGuid}`,
            data,
        }, options));

        return result;
    }
    // 删除部门知识库成员
    async delDepartmentMember(
        memberGuid: string,
        otherParams: {spaceGuid: string, groupGuid: string}
    ) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'DELETE',
            url: `${this.server}/spaces/${otherParams.spaceGuid}/groups/${otherParams.groupGuid}/members/${memberGuid}`,
        }, options));

        return result;
    }
    // 申请，批量邀请，批量修改成员
    async operateDepartmentMember(
        data: any,
        otherParams: {spaceGuid: string, groupGuid: string}
    ) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'post',
            url: `${this.server}/spaces/${otherParams.spaceGuid}/groups/${otherParams.groupGuid}/members`,
            data,
        }, options));
        return result;
    }

    async getHomepageIntroToken(
        spaceGuid: string,
        groupGuid: string,
        repositoryGuid: string,
        docType: string,
        sToken: string
    ) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/rte/${docType}/tokens`,
            method: 'post',
        }, {
            ...options,
            xWikiRteSToken: sToken,
        }));
        return result;
    }

    // 搜索部门成员
    async searchDepartmentMember(
        params: any,
        otherParams: {spaceGuid: string, groupGuid: string}
    ) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/spaces/${otherParams.spaceGuid}/groups/${otherParams.groupGuid}/members`,
            params,
        }, options));
        return result;
    }

    async getSearchData(params: SearchParams) {
        const {spaceGuid} = params;
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/spaces/${spaceGuid}/search`,
            params,
        }, options));
        return result;
    }
    async getRecentViewList(params:{'pageNum': number, 'pageSize': number}) {
        const options = {...this.requestOptions, headers: {'x-wiki-token': this.user?.token, 'Content-Type': 'application/json'}};
        const result = await this.request(Object.assign({
            method: 'post',
            url: `${ServerConfig.ku}/home/search/recent/view`,
            data: params,
        }, options));
        return result;
    }
    async getFeedbackShow() {
        const options = {...this.requestOptions, headers: {'x-wiki-token': this.user?.token, 'Content-Type': 'application/json'}};
        const result = await this.request(Object.assign({
            method: 'post',
            url: `${ServerConfig.ku}/proxy/omni/feedback/show`,
            data: {
                system: 'ku',
                userId: this.user?.avatar,
            },
        }, options));
        return result;
    }
    async feedbackCollect(params:{
        starLevel: number;
        feedbackContent: string;
        query: string;
        queryLogId: string;
    }) {
        const options = {...this.requestOptions, headers: {'x-wiki-token': this.user?.token, 'Content-Type': 'application/json'}};
        const result = await this.request(Object.assign({
            method: 'post',
            url: `${ServerConfig.ku}/proxy/omni/feedback/collect`,
            data: {
                system: 'ku',
                userId: this.user?.avatar,
                ...params,
            },
        }, options));
        return result;
    }
    // 获取知识库简介详情
    async getRepositoryCustomModule(
        spaceGuid: string,
        groupGuid: string,
        repositoryGuid: string,
        docType: string
    ) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/rte/${docType}`,
        }, options));
        return result;
    }

    // 创建知识库简介详情
    async createRepositoryCustomModule(
        spaceGuid: string,
        groupGuid: string,
        repositoryGuid: string,
        docType: string
    ) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'post',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/rte/${docType}`,
        }, options));
        return result;
    }
    // 获取推荐标签
    async getRecommendTags(params: any) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'post',
            url: `${ServerConfig.ku}/tag/doc/detail`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            data: params,
            // eslint-disable-next-line func-names
            transformRequest: [function (data: any) {
                let ret = '';
                for (const it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
                }
                return ret;
            }],
        }, options));
        return result;
    }

    // 知识库标签树
    async treeTags(data: {
        'token': string;
        'repositoryGuid': string;
        'pageNum': number;
        'pageSize': number;
        'recommend': boolean;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/service/v1/tag/gather/tree`,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: {...data},
                },
                options
            )
        );
        return result;
    }

    // tag最近使用
    async getRecentlyView(data: {
        'token': string;
        'repositoryGuid': string;
        'userGuid': string;
        'pageNum': number;
        'pageSize': number;
        'recommend': boolean;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/service/v1/tag/recently/view`,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: {...data},
                },
                options
            )
        );
        return result;
    }

    // tag最近使用采集数据
    async recentlyEvent(data: {
        'token': string;
        'repositoryGuid': string;
        'docGuid': string;
        'tagName': string;
        'email': string;
        'userGuid': string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/service/v1/tag/recently/event`,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: {...data},
                },
                options
            )
        );
        return result;
    }

    // 知识库标签聚合页列表
    async articleListTags(data: {
        'token': string;
        'repositoryGuid': string;
        'userId': string;
        'tagName': string;
        'pageNum': number;
        'pageSize': number;
        'recommend': boolean;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/service/v1/tag/gather/article`,
                    data: {...data},
                },
                options
            )
        );
        return result;
    }

    // 保存知识库简介详情
    async saveRepositoryCustomModule(
        spaceGuid: string,
        groupGuid: string,
        repositoryGuid: string,
        docType: string
    ) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'put',
            url: `${this.server}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/rte/${docType}`,
        }, options));
        return result;
    }

    // 获取成员列表
    async getMemberList(gid: string, spaceGuid: string | undefined, repositoryGuid: string | undefined, docGuid: string | undefined, rlId: string | undefined, groupGuid: string | undefined) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'get',
            url: `${this.server}/open/group/${gid}`,
            params: {
                spaceGuid,
                repositoryGuid,
                docGuid,
                rlId,
                groupGuid,
            },
        }, options));
        return result;
    }

    // 发送权限申请动态卡片消息
    async sendAdminMessages(data: {
        message: string;
        roleName: string;
        spaceGuid: string;
        groupGuid: string;
        repositoryGuid: string;
        docGuid: string;
        memberEvents: Array<{
            memberGuid: string;
            eventGuid: string;
            receiverGuid: string;
        }>;
    }) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'post',
            url: `${this.server}/messages/members/apply`,
            data: {...data},
        }, options));
        return result;
    }


    async sendAdminMessagesSingle(data: {
        message: string;
        roleName: string;
        spaceGuid: string;
        groupGuid: string;
        repositoryGuid: string;
        docGuid: string;
        memberEvent: {
            memberGuid: string;
            eventGuid: string;
            receiverGuid: string;
        };
    }) {
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            method: 'post',
            url: `${ServerConfig.ku}/apply/doc/member`,
            data: {...data},
        }, options));
        return result;
    }

    // 发送@人通知
    async sendNotifyOfMention(data: {
        mentions: Array<{
            mentionId: string;
            userId?: string;
            // 1：划线评论，2：正文, 3: 底部评论
            from: number;
            // 5-用户 7-群聊
            mentionType?: number;
            gid?: string;
            // 0: 不勾选发送通知或撤销通知，1: 勾选发送通知。不传适配老逻辑，也认为是勾选状态
            notifyStatus?: number;
        }>;
        // 1: 卡片消息，2: 公众号消息
        mode: number;
        message?: string;
        needVersion?: boolean;
    }, docInfo?: {
        spaceGuid: string;
        groupGuid: string;
        repositoryGuid: string;
        docGuid: string;
    }, relation?: {
        type: string;
        id: string;
        docGuid: string;
    }) {
        const {spaceGuid, groupGuid, repositoryGuid} = store.getData(store.KEYS.CUR_REPOSITORY);
        const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT);
        const defaultData = {
            spaceGuid,
            groupGuid,
            repositoryGuid,
            docGuid,
            ...docInfo,
            message: '',
            needVersion: false,
        };

        const result = await this.request(
            {
                ...this.requestOptions,
                method: 'post',
                url: `${ServerConfig.ku}/messages/mentions/send`,
                data: {
                    ...defaultData,
                    ...data,
                    relation,
                },
                returnFullResult: true,
                returnFullError: true,
            }
        );
        return result;
    }

    // 收集@人数据
    async collectMention(data: {
        docGuid: string;
        mentions: Array<{
            mentionId: string;
            userId?: string;
            // 1：划线评论，2：正文
            from: number;
            // 5-用户 7-群聊
            mentionType?: number;
            gid?: string;
            // 0: 不勾选发送通知或撤销通知，1: 勾选发送通知。不传适配老逻辑，也认为是勾选状态
            notifyStatus?: number;
        }>;
        relation?: {
            id: string;
            type: 'rightComment';
        };
    }) {
        const result = await this.request(
            {
                ...this.requestOptions,
                method: 'post',
                url: `${ServerConfig.ku}/messages/mentions/store`,
                data,
            }
        );
        return result;
    }

    // 记录@过的用户、文档等
    async postMentionRecord(id: string, type: MentionType = MentionType.contact) {
        const typeMap = {
            contact: 6,
            doc: 25,
            group: 7,
        };
        const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT);
        const {repositoryGuid} = store.getData(store.KEYS.CUR_REPOSITORY);
        return this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.server}/users/${this.user?.userGuid}/records`,
                    data: {
                        objectId: id,
                        // 记录类型，Repository: 20，Doc: 25，MentionUser: 6
                        objectType: typeMap[type],
                        docGuid,
                        repositoryGuid,
                    },
                },
                this.requestOptions
            )
        );
    }

    // 查询的用户、文档等，query为空时返回最近的记录
    async getMentionRecord({query = '', type = 'user'} = {}) {
        return this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.server}/open/mentions`,
                    params: {
                        query,
                        type,
                    },
                },
                this.requestOptions
            )
        );
    }


    // 部门知识库数据看板 =》部门页面数据统计
    async getDocsStatistic(data: {
        spaceGuid: string;
        groupGuid: string;
    }) {
        const options = this.requestOptions;
        const {
            spaceGuid,
            groupGuid,
        } = data;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/docsStatistic/laterHalfHour`,
                },
                options
            )
        );
        return result;
    }

    // 屏蔽星链词条
    async blockEntityLink(data: {
        entityId: string;
    }) {
        return this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.server}/users/${this.user?.userGuid}/linking/block`,
                    data: {
                        entityId: data.entityId,
                        email: this.user?.email,
                        type: 'remove',
                    },
                },
                this.requestOptions
            )
        );
    }

    // 搜索可移入知识库列表
    async searchRepositoriesList(value: string, repositoryGuid: string) {
        assert(this.user);
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.as}/users/${this.user.userGuid}/repositories`,
                    params: {
                        q: value,
                        localRepoGuid: repositoryGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    // 获取企业百科知识库
    async getBaikeRepository() {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.as}/baike/repository`,
            method: 'get',
        });
        return result;
    }

    async getWikiTrans(data: {
        spaceGuid: string;
        groupGuid: string;
    }) {
        const options = this.requestOptions;
        const {
            spaceGuid,
            groupGuid,
        } = data;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/${spaceGuid}/${groupGuid}/wikiTrans`,
                },
                options
            )
        );
        return result;
    }
    async getRecentlyList(params: IRecentlyListParams) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/open/recent`,
                    params,
                },
                options
            )
        );
        return result;
    }
    async getHelperOption() {
        const result = await this.request(
            {
                ...this.requestOptions,
                method: 'get',
                url: `${ServerConfig.ku}/helper/list`,
            }
        );
        return result;
    }

    // 直接由外部传入wikiAccessToken获取rteToken
    // spaceGuid}_${groupGuid}_${repositoryGuid}
    async getEditorTokenWithToken(repositoryGuid: string, docGuid: string, xWikiAccess: string) {
        // 对外场景换了个接口
        if (window.isTocPage) {
            // const options = this.requestOptions;
            const result = await this.request({
                url: `${ServerConfig.ks}/external/repository/doc/getDocRteToken?repositoryGuid=${repositoryGuid}&docGuid=${docGuid}`,
                method: 'get',
                wikiAccessToken: xWikiAccess,
            });
            return result;
        } else {
            // const options = this.requestOptions;
            const result = await this.request({
                url: `${ServerConfig.ks}/${repositoryGuid}/docs/${docGuid}/rteToken`,
                method: 'get',
                wikiAccessToken: xWikiAccess,
            });
            return result;
        }
    }

    async infoQuery({
        spaceGuid,
        groupGuid,
        repositoryGuid,
        docGuid,
        nodeId,
        needRepositoryData,
        wikiAccessToken,
        noAutoLogin,
    }: {
        spaceGuid: string;
        groupGuid: string;
        repositoryGuid: string;
        docGuid?: string;
        nodeId?: string;
        needRepositoryData?: boolean;
        wikiAccessToken?: string;
        noAutoLogin?: boolean;
    }) {

        const options = {
            ...this.requestOptions,
            wikiAccessToken,
        };

        const isTocPage = window.isTocPage;
        const url = isTocPage ? `${ServerConfig.toc}/index/info/query` : `${ServerConfig.ku}/index/info/query`;
        const requestOptions = Object.assign(
            {
                method: 'post',
                url,
                data: {
                    spaceGuid,
                    groupGuid,
                    repositoryGuid,
                    docGuid,
                    nodeId,
                    type: needRepositoryData ? 2 : 1,
                },
            },
            options,
            {
                noAutoLogin,
            }
        );
        const result = await this.request(requestOptions);

        // 复合接口query docStatus或repoStatus异常需要上报weirwood
        const {docStatus, repoStatus} = result;
        const expectCodes = [ErrorCode.uuapExpired, ErrorCode.NoPermission, SuccessCode];
        if (
            (
                docGuid && !expectCodes.includes(docStatus)
                || repoStatus && !expectCodes.includes(repoStatus)
            )
            && !(docStatus === ErrorCode.NotFound && result.wikiInfo)
            && !(repoStatus === ErrorCode.NotFound && result.wikiInfo)
        ) {
            weirwoodApiLog({
                url: requestOptions.url || '',
                method: requestOptions.method || '',
                params: requestOptions.params,
                status: `${SuccessCode}`,
                response: result,
            });
        }
        return result;
    }
    // 发现页面获取高价值知识榜
    async getHighValueDoc({
        pageSize,
        pageNum,
    }: {
       pageSize: number;
        pageNum: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/discovery/highValueDoc/page`,
                    method: 'get',
                    params: {
                        pageSize,
                        pageNum,
                    },
                },
                options
            )
        );
        return result;
    }
    // 发现页面获取知识达人周榜
    async getKnowLedgeExpertList() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/discovery/knowledgeExpert/list`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }
    // 发现tab感知透出取消展示
    async postCancelFindTabDetect({tipsScene}:{tipsScene:number}) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/discovery/tips/cancel`,
                    method: 'post',
                    data: {
                        tipsScene,
                    },
                },
                options
            )
        );
        return result;
    }
    // 发现tab感知透出请求
    async getFindTabDetect() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/discovery/tips/info`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }
    // 发现页面获取公开好文推荐
    async getRecommendDoc({
        pageSize,
        pageNum,
    }: {
       pageSize: number;
        pageNum: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/discovery/feedDoc/page`,
                    method: 'get',
                    params: {
                        pageSize,
                        pageNum,
                    },
                },
                options
            )
        );
        return result;
    }
    // 【首页】获取快捷访问列表
    async getCommonUseKnowledge() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/homepage/knowledge/index`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }
    // 【首页】更新快捷访问列表
    async updateCommonUseKnowledge(order: Array<Pick<ICommonUseKnowledge, 'id' | 'order'>>) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/homepage/knowledge/update`,
                    method: 'post',
                    data: {
                        order,
                    },
                },
                options
            )
        );
        return result;
    }
    // 【首页】添加快捷访问列表
    async addCommonUseKnowledge({
        url,
        knowledge,
    }: {
        url?: string;
        knowledge?: ICommonUseKnowledge[];
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/homepage/knowledge/add`,
                    method: 'post',
                    data: {
                        url,
                        knowledge,
                    },
                },
                options
            )
        );
        return result;
    }

    // 【首页】删除快捷访问列表
    async removeCommonUseKnowledge({
        knowledge,
    }: {
        knowledge: ICommonUseKnowledge[];
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/homepage/knowledge/remove`,
                    method: 'post',
                    data: {
                        knowledge,
                    },
                },
                options
            )
        );
        return result;
    }


    // MARKS: 首页泛知识列表
    // 获取最近浏览
    async getRecentViewKnowledgeList({
        type,
        pageSize,
        pageNum,
    }: {
        type?: SelectDropMenu;
        pageSize: number;
        pageNum: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/homepage/records`,
                    method: 'get',
                    params: {
                        type: type === 0 ? undefined : type,
                        pageSize,
                        pageNum,
                    },
                },
                options
            )
        );
        return result;
    }
    // 获取最近编辑
    async getRecentEditKnowledgeList({
        type,
        pageSize,
        pageNum,
    }: {
        type?: SelectDropMenu;
        pageSize: number;
        pageNum: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/homepage/recent/edit/index`,
                    method: 'get',
                    params: {
                        type: type === 0 ? undefined : type,
                        pageSize,
                        pageNum,
                    },
                },
                options
            )
        );
        return result;
    }
    // 获取我参与的
    async getInvolvedKnowledgeList({
        type,
        involvedType,
        pageSize,
        pageNum,
    }: {
        type?: SelectDropMenu;
        involvedType?: ITableData['involvedType'];
        pageSize: number;
        pageNum: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/homepage/involved`,
                    method: 'get',
                    params: {
                        type: type === 0 ? undefined : type,
                        involvedType,
                        pageSize,
                        pageNum,
                    },
                },
                options
            )
        );
        return result;
    }
    // 获取星标
    async getCollectionKnowledgeList({
        type,
        pageSize,
        pageNum,
        labelIds,
    }: {
        type?: SelectDropMenu;
        pageSize: number;
        pageNum: number;
        labelIds: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/homepage/follow`,
                    method: 'get',
                    params: {
                        type: type === 0 ? undefined : type,
                        pageSize,
                        pageNum,
                        labelIds,
                    },
                },
                options
            )
        );
        return result;
    }
    // 获取热榜知识
    async getHotList() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/homepage/hotList`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }
    // 获取高价值知识
    async getHighQualityList() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/discovery/highValueDoc/briefList`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }
    // 获取重点文档
    // TODO: 助手抽成sdk使用插件引入了，请求的节点太快了，请求时sdk还没初始化好，待上线稳定后把getImportantDocList删掉
    async getImportantDocList() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/homepage/keyList`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    // 最近编辑（临时接口）
    async recentEdit({
        spaceGuid,
        groupGuid,
        repoGuid,
        docGuid,
    }: {
        spaceGuid: string;
        groupGuid: string;
        repoGuid: string;
        docGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/homepage/recent/edit`,
                    method: 'post',
                    data: {
                        spaceGuid,
                        groupGuid,
                        repoGuid,
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    // 获取荣誉墙
    async getHonorWall({
        spaceGuid,
        groupGuid,
        startDate,
        type,
    }: {
        spaceGuid: string;
        groupGuid: string;
        type: string;
        startDate: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/honorWall/${type}`,
                    // url: `${this.mockBaseUrlKu}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/honorWall/${type}`,
                    method: 'get',
                    params: {
                        startDate,
                    },
                },
                options
            )
        );
        return result;
    }

    // 部门首页中知识币数据小流量名单
    async getDepartmentCoinDataWhite() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/white/repo/coin`,
                },
                options
            )
        );
        return result;
    }

    // 根据排序获取文档
    async getHonorDoc({
        spaceGuid,
        groupGuid,
        startDate,
        type,
        orderBy,
        ascending,
        // pageNumber = 1,
        // pageSize = 10,
        endDate,
    }: {
        spaceGuid: string;
        groupGuid: string;
        type: string;
        startDate: number;
        orderBy: string;
        endDate: number;
        ascending?: 'desc' | 'asc' | '';
        // pageNumber?: number;
        // pageSize?: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/teamData/${type}`,
                    // url: `${this.mockBaseUrlKu}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/teamData/${type}`,
                    method: 'get',
                    params: {
                        startDate,
                        orderBy,
                        ascending,
                        // pageNumber,
                        // pageSize,
                        endDate,
                    },
                },
                options
            )
        );
        return result;
    }


    // 部门知识库数据看板 =》部门基本信息统计
    async getDepartmentBaseInfo(spaceGuid: string, groupGuid: string, type: string, startDate: number, endDate: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/groupAnalyData/${type}`,
                    // url: 'https://yapi.baidu-int.com/mock/13783/wiki/ku/dashboard/spaceGuid/{spaceGuid}/groupGuid/{groupGuid}/groupAnalyData/{type}',
                    params: {
                        startDate,
                        endDate,
                    },
                },
                options
            )
        );
        return result;
    }

    // 部门统计看板=》获取知识成员数据
    async getKnowledgeAndMemberData(spaceGuid: string, groupGuid: string, type: string, startDate: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    // url: `${this.mockBaseUrlKu}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/groupAnalyDataMember/${type}`,
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/groupAnalyDataMember/${type}`,
                    method: 'get',
                    params: {startDate},
                },
                options
            )
        );
        return result;
    }

    // 部门统计看板=》获取协作数据
    async getknowledgeSynergia(spaceGuid: string, groupGuid: string, type: string, startDate: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/getAnalyDocSynergy/${type}`,
                    method: 'get',
                    params: {
                        startDate,
                    },
                },
                options
            )
        );
        return result;
    }
    // 部门统计看板=>时间选择
    async getDepartmentDateStart(spaceGuid: string, groupGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/datePicker`,
                    // url: `${this.mockBaseUrlKu}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/datePicker`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }


    // 部门知识库数据看板 =》 部门知识库统计信息（部门表格数据）
    async getDepartmentRepoTable(data: {
        spaceGuid: string;
        groupGuid: string;
        pageSize: number;
        pageNumber: number;
        ascending: 'asc' | 'desc' | '';
        orderBy: string;
        type: string;
        startDate: number;
        endDate: number;
    }) {
        const options = this.requestOptions;
        const {
            spaceGuid,
            groupGuid,
            ...params
        } = data;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/repoData/${data.type}`,
                    params,
                },
                options
            )
        );
        return result;
    }


    // 部门知识库数据看板 =》 部门知识库统计信息（成员表格数据）
    async getDepartmentDocTable(data: {
        spaceGuid: string;
        groupGuid: string;
        pageSize: number;
        pageNumber: number;
        ascending: 'asc' | 'desc' | '';
        orderBy: string;
        type: string;
        startDate: number;
        endDate: number;
    }) {
        const options = this.requestOptions;
        const {
            spaceGuid,
            groupGuid,
            ...params
        } = data;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/memberInfo/${data.type}`,
                    params,
                },
                options
            )
        );
        return result;
    }

    // 部门知识库数据看板 =》 部门知识库详情下载
    async getDepartmentRepoTableDownload(data: {
        spaceGuid: string;
        groupGuid: string;
        type: string;
    }, query: {
        startDate: number;
        endDate: number;
        orderBy: string;
        ascending: string;
    }) {
        const options = this.requestOptions;
        const {
            spaceGuid,
            groupGuid,
            type,
        } = data;
        const result = await downloadToData(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/repoData/${type}/download`,
                    params: query,
                },
                options
            ),
            this.addFrontTraceInfo
        );
        return result;
    }

    // 部门知识库数据看板 =》 部门文档详情下载
    async getDepartmentDocTableDownload(data: {
        spaceGuid: string;
        groupGuid: string;
        type: string;
    }, query: {
        startDate: number;
        endDate: number;
        orderBy: string;
        ascending: string;
    }) {
        const options = this.requestOptions;
        const {
            spaceGuid,
            groupGuid,
            type,
        } = data;
        const result = await downloadToData(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/groupAnalyStatistic/${type}/download`,
                    params: query,
                },
                options
            ),
            this.addFrontTraceInfo
        );
        return result;
    }
    // 目录树搜索接口
    async getRepoDocSide(data: {
        pageNo: number;
        pageSize: number;
        word: string;
        repoGuid: string[];
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/search/side/repo`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 组织入口开发，接口废弃
    // async getManageDepartmentCount() {
    //     const options = this.requestOptions;
    //     const result = await this.request(
    //         Object.assign(
    //             {
    //                 url: `${ServerConfig.ku}/homepage/departmentCount`,
    //                 method: 'get',
    //             },
    //             options
    //         )
    //     );
    //     return result;
    // }

    // 组织知识库开发，接口替换，该接口废弃
    // async getManageDepartments(params: any) {
    //     const options = this.requestOptions;
    //     const result = await this.request(
    //         Object.assign(
    //             {
    //                 url: `${ServerConfig.ku}/homepage/depAggregation`,
    //                 method: 'get',
    //                 params,
    //             },
    //             options
    //         )
    //     );
    //     return result;
    // }
    // 组织知识库开发，接口替换，该接口废弃
    // async downloadManageDepartments(params: any) {
    //     const options = this.requestOptions;
    //     const result = await downloadToData(
    //         Object.assign(
    //             {
    //                 method: 'get',
    //                 url: `${ServerConfig.ku}/homepage/depAggregationData/download`,
    //                 params: params,
    //             },
    //             options
    //         )
    //     );
    //     return result;
    // }

    // 部门公告 - 获取列表
    async getDepartmentNoticeList(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/list`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 部门公告 - 添加公告
    async addDepartmentNotice(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/create`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 部门公告 - 发布接口
    async publishDepartmentNotice(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/content`,
                    method: 'post',
                    data,
                    returnFullResult: true,
                    returnFullError: true,
                },
                options
            )
        );
        return result;
    }

    // 部门公告 - 获取基本信息
    async getDepartmentNoticeInfo(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/getContent`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 部门公告 - 获取编辑状态信息
    async getDepartmentNoticeEditInfo(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/editInfo`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 部门公告 - 删除公告
    async deleteDepartmentNotice(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/delInfo`,
                    method: 'delete',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 部门公告 - 检查部门公告编辑锁的状态
    async checkDepartmentNoticeLock(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/isEditLock`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 部门公告 - 撤掉部门公告的编辑锁
    async cancelDepartmentNoticeLock(data: any) {
        const options = this.requestOptions;
        // 重要：因为要在页面完全关闭时，即unload时发送请求，所以使用fetch（XMLHttpRequest请求在unload中会被忽略）
        await window.fetch(`${ServerConfig.ku}/km/dept/notice/v1/cancel`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-wiki-token': options.wikiToken || '',
            },
            body: JSON.stringify(data),
            keepalive: true, // 重要！！！必须要有
        });
    }

    // 部门公告 - 删除垃圾数据
    async deleteDepartmentNoticeTrash(data: any) {
        const options = this.requestOptions;
        // 重要：因为要在页面完全关闭时，即unload时发送请求，所以使用fetch（XMLHttpRequest请求在unload中会被忽略）
        await window.fetch(`${ServerConfig.ku}/km/dept/notice/v1/clean/trashNotice`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-wiki-token': options.wikiToken || '',
            },
            body: JSON.stringify(data),
            keepalive: true, // 重要！！！必须要有
        });
    }

    // 部门公告 - 查询如流群（原 `${ServerConfig.ku}/rul/group/searchGroup` 接口）
    async searchInfoFlowGroup(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/im/bindDeptGroup`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 部门公告 - 解绑如流群
    async unBoundFlowGroup(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/im/unbindDeptGroup`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 部门公告 - 查询如流群历史记录（原 `${ServerConfig.ku}/km/dept/notice/v1/read/history/groups` 接口）
    async getDepartmentNoticeGroupHistory(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/im/checkGroup`,
                    method: 'post',
                    data,
                    returnFullError: true,
                },
                options
            )
        );
        return result;
    }

    // 部门首页 / 全部公告 / 发布公告 - 获取@全员设置开关
    async getAiteAllPeopleSetting(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/im/atMember`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 部门首页 / 全部公告 / 发布公告 - 消息置顶
    async getMsgAtTopSetting(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/im/topMsg`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 部门公告 - 置顶或取消置顶
    async setTopDepartmentNotice(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/position`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 部门公告 - 获取阅读状态列表
    async getDepartmentNoticeReadList(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/read/list`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }


    // 部门公告 - 下载阅读状态列表
    async downloadDepartmentNoticeReadList(data: any) {
        const options = this.requestOptions;
        const result = await downloadToData(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/read/export`,
                    method: 'post',
                    data,
                },
                options
            ),
            this.addFrontTraceInfo
        );
        return result;
    }

    // 部门公告 - 查询某个公告文档的是否已阅读
    async getDepartmentNoticeReadStatus(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/read/status`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 部门公告 - 设置某个公告文档的是否已阅读
    async setDepartmentNoticeRead(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/dept/notice/v1/read/setTime`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    async getRecentBrowse(params: {page: number, pagesize: number}) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/home/search/preview`,
                    method: 'get',
                    params,
                },
                options
            )
        );
        return result;
    }

    async getRelatedPerson(params: {query: string}) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/home/search/recommend/person`,
                    method: 'post',
                    data: params,
                },
                options
            )
        );
        return result;
    }

    async addRecentBrowse(item: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/home/search/preview`,
                    method: 'post',
                    data: item,
                },
                options
            )
        );
        return result;
    }

    async getHistorySearchWord() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/home/search/query/history`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    async addHistorySearchWord() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/home/search/query/history`,
                    method: 'post',
                },
                options
            )
        );
        return result;
    }

    async clearHistorySearchWord() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/home/search/query/history`,
                    method: 'delete',
                },
                options
            )
        );
        return result;
    }

    async getRecommendQuery(params: {query: string}) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/home/search/query/recommend`,
                    method: 'post',
                    data: params,
                },
                options
            )
        );
        return result;
    }

    async getSearchDataFromSearchPage(params: SearchParamsFromSearchPage) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/home/search`,
                    method: 'post',
                    data: params,
                },
                options
            )
        );
        return result;
    }

    async clearSearchHistoryWordFromSearchPage() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/home/search/query/history`,
                    method: 'delete',
                },
                options
            )
        );
        return result;
    }

    async addSearchHistoryWordFromSearchPage(query: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/home/search/query/history`,
                    method: 'post',
                    data: {query},
                },
                options
            )
        );
        return result;
    }

    // 部门首页的改版接口
    async getDepartmentRecommendRepo(params: {
        spaceGuid: string;
        groupGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    url: `${ServerConfig.ku}/group/recommend/repo/list`,
                    method: 'get',
                    params,
                }
            )
        );
        return result;
    }

    async setDepartmentRecommendRepo(data: {
        spaceGuid?: string;
        groupGuid?: string;
        topRepoGuid?: string;
        topRepoUrl?: string;
        action: number; // 1-置顶；2-取消置顶
        // 当前部门的信息
        // 上面的参数都是备操作部门的信息
        refer: {
            spaceGuid: string;
            groupGuid: string;
        };
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    url: `${ServerConfig.ku}/group/recommend/repo/top`,
                    method: 'post',
                    data,
                }
            )
        );
        return result;
    }

    // 部门首页数据概览
    async getDataOverview(spaceGuid: string, groupGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/kmInfo`,
                    method: 'get',
                }
            )
        );
        return result;
    }

    /**
    * 获取一个 docGuid
    */
    async getDocGuid() {
        const options = this.requestOptions;

        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/doc/docGuid/new`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    // 部门知识库数据看板 =》 数据总览下载
    async getDepartmentStatisticsDataDownload(data: {
        spaceGuid: string;
        groupGuid: string;
        type: string;
    }, query: {
        startDate: number;
        endDate: number;
    }) {
        const options = this.requestOptions;
        const {
            spaceGuid,
            groupGuid,
            type,
        } = data;
        const result = await downloadToData(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/analyGroupData/${type}/download`,
                    params: query,
                },
                options
            ),
            this.addFrontTraceInfo
        );
        return result;
    }

    // 部门知识库下知识库 =》 知识库表导出
    async getDepartmentTableDownload(data: {
        spaceGuid: string;
        groupGuid: string;
        title: string;
    }) {
        const options = this.requestOptions;
        const result = await downloadToData(
            Object.assign(
                options,
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/km/dept/repo/v1/export`,
                    data: data,
                }
            ),
            this.addFrontTraceInfo
        );
        return result;
    }

    // 获取文档关注状态
    async getAttentionDocDynamics(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/subscribe/v2/doc/status?docGuid=${docGuid}`,
                }
            )
        );
        return result;
    }

    // 获取文档关注状态V1
    async getAttentionDocDynamicsV1(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/subscribe/doc/status?docGuid=${docGuid}`,
                }
            )
        );
        return result;
    }

    // 关注文档动态
    async addAttentionDocDynamics(docGuid: string, subscribeType?: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    method: 'put',
                    url: `${ServerConfig.ku}/subscribe/v2/doc?docGuid=${docGuid}`,
                    params: {
                        subscribeType,
                    },
                }
            )
        );
        return result;
    }

    // 关注文档动态V1
    async addAttentionDocDynamicsV1(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    method: 'put',
                    url: `${ServerConfig.ku}/subscribe/doc?docGuid=${docGuid}`,
                }
            )
        );
        return result;
    }

    // 取消关注文档动态
    async cancelAttentionDocDynamics(docGuid: string, subscribeType?: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    method: 'delete',
                    url: `${ServerConfig.ku}/subscribe/v2/doc?docGuid=${docGuid}`,
                    params: {
                        subscribeType,
                    },
                }
            )
        );
        return result;
    }

    // 取消关注文档动态V1
    async cancelAttentionDocDynamicsV1(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    method: 'delete',
                    url: `${ServerConfig.ku}/subscribe/doc?docGuid=${docGuid}`,
                }
            )
        );
        return result;
    }

    // 获取首页我关注的列表数据
    async getMyAttentionDocs(params: {
        type?: SelectDropMenu;
        subscribeType: string;
        pageSize: number;
        pageNum: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/homepage/subscribe/v2/list`,
                    data: params,
                }
            )
        );
        return result;
    }
    async getMyRepositoryList({
        type,
        pageSize,
        pageNum,
    }: {
        type?: SelectDropMenu;
        pageSize: number;
        pageNum: number;
    }) {
        const options = this.requestOptions;
        const roleAdmin = 1;
        const roleType = type === SELECT_DROPMENU.myAdminRepository ? roleAdmin : '';
        const result = await this.request(
            Object.assign(
                options,
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/homepage/repo/list`,
                    params: {
                        roleType,
                        pageSize,
                        pageNum,
                    },
                }
            )
        );
        return result;
    }

    async addAnchorReport(params: { // 底部评论上报锚点等评论信息，用于发送通知
        type: number;
        docGuid: string;
        repoGuid: string;
        commentGuid: string;
        commentId: string;
        anchorGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/anchor/report`,
                    data: params,
                }
            )
        );
        return result;
    }

    async getMessageOptimizeInWhiteList() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/white/notice/v1`,
                }
            )
        );
        return result;
    }

    // 查看当前知识库所属的已确权部门
    async getAuthenticRightDepts(params: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/repository/members/certainGroup`,
                    method: 'get',
                    params,
                },
                options
            )
        );
        return result;
    }

    // 知识库在部门内公开（添加）
    async addRepositoryInDept(params: any, data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/repository/members/create`,
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    params,
                    data,
                },
                options
            )
        );
        return result;
    }

    // 知识库在部门内公开（移除）
    async deleteRepositoryInDept(params: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/repository/members/delete`,
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    params,
                },
                options
            )
        );
        return result;
    }

    // 查询用户创建知识库的所属部门信息
    async getUserCreateBelongDept(params: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/group/userBelongTo`,
                    method: 'get',
                    params,
                },
                options
            )
        );
        return result;
    }

    // 获取有权限目录列表
    async getPermissionDirList(repositoryGuid: string, parentGuid?: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/docs/access/dir`,
                    params: {
                        repositoryGuid,
                        parentGuid,
                    },
                },
                options
            )
        );
        return result as WizDocument[];
    }

    // 获取用户使用知识币记录信息-分页列表【弹窗数据】
    async giveCoinsAvailableLog(pageSize: number, pageNum: number) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/user/coin/available/log?pageSize=${pageSize}&pageNum=${pageNum}`,
            method: 'get',
        });
        return result;
    }

    // 获取发布文档列表-弹窗数据-推荐列表
    async getSuggestionCategoryList(params: {
        category: number | undefined;
        switchPage: boolean;
    }) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/personal/homepage/publish/doc/suggestion/category`,
            method: 'get',
            params: params,
        });
        return result;
    }

    // 获取文档发布建议气泡信息
    async getSuggestionTipsInfo() {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/personal/homepage/publish/doc/suggestion/tips/info`,
            method: 'get',
        });
        return result;
    }

    // 取消用户发布文档建议气泡信息
    async cancelSuggestionTips(tipsScene: number) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/personal/homepage/publish/doc/suggestion/tips/cancel`,
            method: 'post',
            data: {
                tipsScene,
            },
        });
        return result;
    }

    // 获取发布文档列表-分页列表【弹窗数据】
    async getPublishDocList(pageSize: number, pageNum: number) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/personal/homepage/publish/doc/suggestion?pageSize=${pageSize}&pageNum=${pageNum}`,
            method: 'get',
        });
        return result;
    }
    // 批量发布文档
    async setPublishDocListMultiple(checkList: IPublishListData[]) {
        const docInfos = checkList.map(ite => {
            return {
                spaceGuid: ite.spaceGuid,
                groupGuid: ite.groupGuid,
                repositoryGuid: ite.repositoryGuid,
                docGuid: ite.docGuid,
            };
        });
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/personal/homepage/publish/doc/batchPublish`,
            method: 'post',
            data: {
                docInfos,
            },
        });
        return result;
    }
    // 用户获得知识币动态列表-分页列表【列表数据】
    async getCoinReceivedLog(pageSize: number, pageNum: number, knowledgeType?: number) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/user/coin/received/log`,
            method: 'get',
            params: {
                pageSize,
                pageNum,
                knowledgeType,
            },
        });
        return result;
    }

    // 用户获赞列表-分页列表【列表数据】
    async getLikeListLog(pageSize: number, pageNum: number) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/personal/homepage/achieve/docLike/log`,
            method: 'get',
            params: {
                pageSize,
                pageNum,
            },
        });
        return result;
    }

    // 用户获得知识币动态列表-分页列表【列表数据】
    async getRecentDynamicData(userGuid: string, pageSize: number, pageNum: number) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/personal/homepage/activity?userGuid=${userGuid}&pageSize=${pageSize}&pageNum=${pageNum}`,
            method: 'get',
        });
        return result;
    }
    // 个人主页 通过userName获取userGuid
    async queryUserGuidByName(userName: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/users/query`,
                    // url: 'https://yapi.baidu-int.com/mock/13783/wiki/ku/users/query',
                    params: {
                        avatar: userName,
                    },
                },
                options
            )
        );
        return result;
    }
    // 个人主页 获取用户背景图
    async getPersonalHomeBackground(personalHomeUserGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/background/image`,
                    params: {
                        userGuid: personalHomeUserGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 个人主页 获取当前用户知识币信息
    async queryUserCoinInfo() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/user/coin/info`,
                },
                options
            )
        );
        return result;
    }
    // 个人主页 获取每日一句
    async getPersonalHomeSaying(personalHomeUserGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/daily/sentence`,
                    params: {
                        userGuid: personalHomeUserGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 个人主页 获取背景图
    async getPersonalHomeBackgroundList(page = 1, pageSize = 30) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/background/image/list`,
                    params: {
                        page,
                        pageSize,
                    },
                },
                options
            )
        );
        return result;
    }
    // 个人主页 更新背景图
    async updatePersonalHomeBackground(imageId: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/personal/homepage/background/image/switch`,
                    data: {
                        imageId,
                    },
                },
                options
            )
        );
        return result;
    }

    // 个人主页 分享个人主页页面
    async sharePersonalPage({
        shareUserGuid,
        shareMembers,
    }: {
        shareUserGuid: string;
        // 时间跨度类型 0:累计；1:今日；2:近7天；3:近30天；
        shareMembers: Array<{avatar: string, gid: string, name?: string}>;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    // url: 'https://yapi.baidu-int.com/mock/13783/personal/homepage/shares',
                    url: `${ServerConfig.ku}/personal/homepage/shares`,
                    data: {
                        shareUserGuid,
                        shareMembers,
                    },
                },
                options
            )
        );
        return result;
    }
    // 个人主页 更新每日一句
    async updatePersonalHomeSaying() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/personal/homepage/daily/sentence/switch`,
                },
                options
            )
        );
        return result;
    }
    // 个人主页基本信息：如知识助手黑名单等
    async getHomePageSubInfo({
        userGuid,
    }: {
        userGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/info`,
                    params: {
                        userGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 获取公开发布列表
    async getPublishList(query: {
        personalHomeUserGuid: string;
        pageNum: number;
        pageSize: number;
    }) {
        const options = this.requestOptions;
        const {personalHomeUserGuid, pageNum, pageSize} = query;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/publish/doc/list`,
                    params: {
                        userGuid: personalHomeUserGuid,
                        pageNum,
                        pageSize,
                    },
                },
                options
            )
        );
        return result;
    }
    // 获取文档列表
    async getDocList(query: {
        personalHomeUserGuid: string;
        pageNum: number;
        pageSize: number;
        type: string;
        timeFlag?: string;
    }) {
        const options = this.requestOptions;
        const {personalHomeUserGuid, type, pageNum, pageSize, timeFlag} = query;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/doc/list`,
                    params: {
                        userGuid: personalHomeUserGuid,
                        pageNumber: pageNum,
                        pageSize,
                        type,
                        timeFlag,
                        isPC: 1,
                    },
                },
                options
            )
        );
        return result;
    }
    // 获取个人主页Tab
    async getDocTab(query: {
        userGuid: string;
    }) {
        const options = this.requestOptions;
        const {userGuid} = query;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/doc/tab`,
                    params: {
                        userGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 修改文档列表可见性
    async updateDocVisibility(params: {
        visibility: string;
        listType: string;
        docGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/personal/homepage/doc/visibility/update`,
                    data: params,
                },
                options
            )
        );
        return result;
    }

    // 个人知识成就
    async getPersonalAttainment(personalHomeUserGuid: string, size: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/achieve/awards`,
                    params: {
                        userGuid: personalHomeUserGuid,
                        size,
                    },
                },
                options
            )
        );
        return result;
    }
    // 个人创作与阅读量
    async getPersonalCreateAndRead(
        personalHomeUserGuid: string,
        timeSpanType: number// 时间跨度类型 0:累计；1:今日；2:近7天；3:近30天；
    ) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/achieve/produce`,
                    params: {
                        userGuid: personalHomeUserGuid,
                        timeSpanType,
                    },
                },
                options
            )
        );
        return result;
    }

    // 是否在个人主页小流量名单中
    async getIsOpenAddPersonalHome() {
        const options = this.requestOptions;

        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/white/coin/v1`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    // 获取知识币规则页面数据
    async getRulesPageValues() {
        const options = this.requestOptions;

        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/user/coin/rule`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    async getAigcWhiteList() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/white/chat/whites`,
                },
                {
                    ...options,
                    timeout: 3000,
                }
            )
        );
        return result;
    }

    // 获取当前知识库的部门公开信息
    async getPublicGroupId(repositoryGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/repository/openToGroup`,
                    params: {repositoryGuid},
                },
                options
            )
        );
        return result;
    }

    // 知识库移动进部门
    async repoMoveInGroup(repoGuidList: string[], toGroupGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/repository/moveIn/notice`,
                    data: {
                        repositoryGuidList: repoGuidList,
                        toGroupGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    // 搜索可移入知识库列表的目录树
    async repositoriesDocTreeList(query: {
        toRepoGuid: any;
        toParentGuid: any;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/repository/dirDocs`,
                    params: query,
                },
                options
            )
        );
        return result;
    }

    // 星标新建分组
    async addStarGroup(labelName: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/label/add`,
                    // url: 'https://yapi.baidu-int.com/mock/13783/label/add',
                    data: {
                        labelName,
                    },
                },
                options
            )
        );
        return result;
    }

    // 发布文档置顶，取消置顶
    async postDocToTop(repositoryGuid: string, docGuid: string, isSetToTop: boolean) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/personal/homepage/publish/doc/top`,
                    data: {
                        repositoryGuid,
                        docGuid,
                        // 1:置顶,2:取消置顶
                        action: isSetToTop ? 1 : 2,
                    },
                    options,
                }
            )
        );
        return result;
    }

    // 获取所有分组标签
    async getAllStarGroup() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/label/list`,
                    // url: 'https://yapi.baidu-int.com/mock/13783/label/list',
                },
                options
            )
        );
        return result;
    }

    // 删除分组标签
    async deleteStarGroup(labelIds: string[] | number[]) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'delete',
                    url: `${ServerConfig.ku}/label/delete`,
                    // url: 'https://yapi.baidu-int.com/mock/13783/label/delete',
                    data: {labelIds},
                },
                options
            )
        );
        return result;
    }

    // 分组标签重命名
    async renameStarGroup(id: number, tagName: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'put',
                    url: `${ServerConfig.ku}/label/${id}`,
                    data: {
                        labelName: tagName,
                    },
                },
                options
            )
        );
        return result;
    }

    // 星标文件 / 知识库 绑定分组标签
    async bindStarGroup(followGuid: string, labelIds: number[]) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/label/follow/group`,
                    // url: 'https://yapi.baidu-int.com/mock/13783/label/follow/group',
                    data: {
                        followGuid,
                        labelIds,
                    },
                },
                options
            )
        );
        return result;
    }

    // 星标-获取分组Id的已绑定星标数量
    async getStarBindGroup(labelId: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/label/group`,
                    params: {labelId},
                },
                options
            )
        );
        return result;
    }

    // 部门知识库数据看板 =》部门基本信息统计新增的数据
    async getDepartmentBaseInfoNew(spaceGuid: string, groupGuid: string, type: string, startDate: number, endDate: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/dashboard/spaceGuid/${spaceGuid}/groupGuid/${groupGuid}/kmData/${type}`,
                    params: {
                        startDate,
                        endDate,
                    },
                },
                options
            )
        );
        return result;
    }

    async reportVisitPersonalPage(interviewee: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/notice/visited/personalHomepage`,
                    params: {
                        interviewee,
                    },
                },
                options
            )
        );
        return result;
    }

    async getPersonalRecommendList(changeBatch: boolean) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/personal/homepage/recommend/doc`,
                    data: {
                        changeBatch,
                    },
                },
                options
            )
        );
        return result;
    }

    async getFeedDocList() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/discovery/feedDoc/briefList`,
                },
                options
            )
        );
        return result;
    }

    // 安全设置-可见范围（只用来修改知识库层）
    async updateRepositoryVisible(repository: Repository) {
        const options = this.requestOptions;
        delete repository.invitation;
        const result = await this.request(
            Object.assign(
                {
                    method: 'put',
                    url: `${ServerConfig.ku}/space/groups/repositories/visible`,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: repository,
                },
                options
            )
        );
        return result;
    }
    // 获取勋章成就数据
    async getAchieveList(userGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/medal/list`,
                    params: {
                        userGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 获取需要屏蔽的团队信息
    async getShieldGroupData() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/km/od/group/blacklist`,
                },
                options
            )
        );
        return result;
    }

    async getPersonalReport(groupGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/summary`,
                    params: {
                        groupGuid,
                    },
                },
                options
            )
        );

        return result;
    }

    // 小流量 - 超级助理「文案修改，原先为智能洞察」摘要文档
    async getAiChatDocWhiteList(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/white/ai/doc/summary`,
                    params: {
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    async getExchangeEasyCoinLog(params: {
        pageSize: number;
        pageNum: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/user/coin/exchange/log`,
                    // url: `${this.mockBaseUrlKu}/user/coin/exchange/log`,
                    params: params,
                },
                options
            )
        );
        return result;
    }
    // 获取上级组织信息
    async getOrganizationInfo() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/km/gudt/entrance/parent`,
                },
                options
            )
        );
        return result;
    }

    // 获取我管理的组织/部门数量（首页新接口，原接口废弃）
    async getGroupManageCount() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/km/gudt/entrance/manage`,
                },
                options
            )
        );
        return result;
    }
    // 获取首页Banner列表
    async getBannerList() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/banner/homepage/list`,
                },
                options
            )
        );
        return result;
    }
    async exchangeEasyCoin(exchangeCoinCount: number, limitActivity?: boolean) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/user/coin/exchange/easyCoin`,
                    // url: `${this.mockBaseUrlKu}/user/coin/exchange/easyCoin`,
                    data: {
                        exchangeCoinCount,
                        limitActivity,
                    },
                },
                options
            )
        );
        return result;
    }
    // 获取我管理的组织/部门列表
    async getGroupManageList(params: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/km/gudt/entrance/manage/list`,
                    method: 'post',
                    data: params,
                },
                options
            )
        );
        return result;
    }

    async downloadManageDepartments(params: any) {
        const options = this.requestOptions;
        const result = await downloadToData(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/km/gudt/entrance/manage/download`,
                    data: params,
                },
                options
            ),
            this.addFrontTraceInfo
        );
        return result;
    }

    // 个人主页设置知识库入口可见
    async setPersenalShowRepoEntry(visibility: IPersenalShowRepoEntry) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/personal/homepage/personalRepo/update`,
                    data: {
                        visibility,
                    },
                },
                options
            )
        );
        return result;
    }
    // 开启关闭问答能力
    async settingQuestionAnswer({
        repoGuid,
        chatRepo,
    }: {
        chatRepo: string;
        repoGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/chat/repo/${repoGuid}/setting`,
                    data: {
                        chatRepo, // 1:开启 2: 关闭
                    },
                },
                options
            )
        );
        return result;
    }

    // 查询是否已经设置了问答的开启（开启之后还需要初始化这个时候并不具备问答能力，查询的只是设置的值）
    async getQuestionAnswerSwitch(repoGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/chat/repo/${repoGuid}/setting`,
                },
                options
            )
        );
        return result;
    }
    // 查询当前知识库是否支持发起提问
    async questionAnswerIsOpen(repoGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/chat/repo/support/${repoGuid}`,
                },
                options
            )
        );
        return result;
    }

    // 获取问答推荐列表
    async getQuestionAnswerRecommendList(repoGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/chat/repo/${repoGuid}/questions`,
                },
                options
            )
        );
        return result;
    }
    // 问答发起提问
    async sendQuestion({
        query,
        repoGuid,
        source,
    }: {
        query: string;
        repoGuid: string;
        source: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.origin}/wiki/ai/chat/repo/${repoGuid}`,
                    data: {
                        query,
                        source,
                    },
                },
                options
            )
        );
        return result;
    }

    // 保存问答
    async saveQuestionAnswer({
        repoGuid,
        ...data
    }: {
        question: string;
        repoGuid: string;
        blockId: string;
        id: string;
        answer: string;
        source?: string;
        responder?: string;
        refer?: IRefer[];
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/chat/repo/${repoGuid}/record`,
                    data,
                },
                options
            )
        );
        return result;
    }

    // 查询问答历史记录
    async getQuestionAnswerHistory(repoGuid: string, source: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/chat/repo/${repoGuid}/records`,
                    params: {
                        source,
                    },
                },
                options
            )
        );
        return result;
    }

    // 查询赞踩原因
    async getLikeReason() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/chat/repo/feedback/comment/list`,
                },
                options
            )
        );
        return result;
    }

    // 提交回答反馈
    async sendAnswerFeedbackComment({repoGuid, ...data}: {
        repoGuid: string;
        blockId: string;
        id: string;
        evaluationId?: string[];
        comment?: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/chat/repo/${repoGuid}/feedback/comment`,
                    data,
                },
                options
            )
        );
        return result;
    }

    // 点赞点踩
    async sendAnswerFeedback({repoGuid, ...data}: {
        repoGuid: string;
        blockId: string;
        id: string;
        like: ILike;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/chat/repo/${repoGuid}/feedback`,
                    data,
                },
                options
            )
        );
        return result;
    }

    // 查询问答初始化进度
    async getQuestionAnswerRefresh(repoGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/chat/repo/${repoGuid}/refresh`,
                },
                options
            )
        );
        return result;
    }

    // 获取用户成就信息
    async getUserAchieveInfo() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/homepage/achieve/userInfo`,
                },
                options
            )
        );
        return result;
    }

    // 获取用户部门收益用户
    async getUserDepartmentGainCoinUser() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/homepage/achieve/group/coinReceiverList`,
                },
                options
            )
        );
        return result;
    }
    // 取消用户的可用知识币过期提醒
    async cancelUserUsableCoinRemindTip() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/homepage/achieve/cancelRewardCoinTips`,
                },
                options
            )
        );
        return result;
    }
    // 个人主页查询盲盒奖励总览信息
    async getMysteryBoxSummary(userGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/prize/summary`,
                    params: {userGuid},
                },
                options
            )
        );
        return result;
    }

    // 获取ku问答首页三个默认问题
    async getKuQAThreeQuestions(repositoryGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/chat/repo/${repositoryGuid}/questions/recommend`,
                },
                options
            )
        );
        return result;
    }

    // 问答分享到如流
    async QAShareToRuLiu(repoGuid: string, receivers: Array<{chatId: string | number, chatType: 1 | 2}>) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/rl/share/chatRepo`,
                    data: {
                        repoGuid,
                        receivers: receivers,
                    },
                },
                options
            )
        );
        return result;
    }
    async getHotKnowledgeList(userGuid: string, pageSize: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/community/hot/knowledge/feed`,
                    params: {
                        userGuid,
                        pageSize,
                    },
                },
                options
            )
        );
        return result;
    }
    // 个人主页查询指定盲盒奖励的详情信息
    async getMysteryBoxDetailInfo(userGuid: string, prizeGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/prize/detail`,
                    params: {
                        userGuid,
                        prizeGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    // 获取ku问答开启状态
    async QASettingQuery(repositoryGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/chat/repo/${repositoryGuid}/page/setting`,
                },
                options
            )
        );
        return result;
    }
    // 更新问答状态
    // 开启关闭
    async QASettingUpdate({
        repoGuid,
        ...data
    }: {
        repoGuid: string;
        chatRepo?: string;
        welcome?: string;
        recommends?: string[];
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/chat/repo/${repoGuid}/page/setting`,
                    data,
                },
                options
            )
        );
        return result;
    }

    async getRecommendList(params: {
        userGuid: string;
        head: string;
        tail: string;
        action: IRecommednFeedAction;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/community/feed/list`,
                    params: params,
                },
                options
            )
        );
        return result;
    }
    // 个人主页查询盲盒奖励指定分类的手机记录
    async getMysteryBoxGainLog(params: {
        userGuid: string;
        prizeGuid: string;
        pageSize: number;
        pageNum: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/prize/log`,
                    params: params,
                },
                options
            )
        );
        return result;
    }


    // 设置问答问题
    async QASetting(repositoryGuid: string, welcome:string, recommends: string[], fallback: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/chat/repo/${repositoryGuid}/page/setting`,
                    data: {
                        recommends: recommends,
                        welcome: welcome,
                        fallback: fallback,
                    },
                },
                options
            )
        );
        return result;
    }
    // 知识广场、知识库个人主页融合——取消点赞功能
    async homeCancelLike(
        userGuid: string,
        docGuid: string,
        resourceId: string,
        source: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'delete',
                    url: `${ServerConfig.ku}/community/like/del`,
                    params: {
                        userGuid,
                        docGuid,
                        resourceId,
                        source,
                    },
                    // wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 获取权限回收数据
    async getPowerRecycleNum(groupGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/group/groupAuthRisk`,
                    params: {
                        groupGuid: groupGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    // 获取是否拥有权限回收入口
    async getHasPowerRecycleEntry(groupGuid: string, type?: 'index' | 'tab') {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/group/global`,
                    params: {
                        groupGuid: groupGuid,
                        type: type || 'tab',
                    },
                },
                options
            )
        );
        return result;
    }

    // 获取权限风险二级页数据
    async getPowerDangerWarn(pageNum: number, pageSize: number, groupGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/group/risk/info`,
                    params: {
                        pageNum,
                        pageSize,
                        groupGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 部门知识库获取未回收风险汇总数
    async getDepartmentUnRecyclePowerRiskSummary(groupGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/group/risk/detail/summary`,
                    params: {
                        groupGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 部门知识库获取权限风险详情页面人员数据
    async getDepartmentPowerRiskPersonnelList(parmas: {
        groupGuid: string;
        historyId?: string;
        startDate?: number;
        endDate?: number;
        pageNum: number;
        pageSize: number;
        userGuid?: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/group/risk/user/list`,
                    params: parmas,
                },
                options
            )
        );
        return result;
    }
    // 部门知识库获取权限风险详情页面人员文档知识库明细数据
    async getDepartmentPowerRiskPersonnelDetailList(parmas: {
        groupGuid: string;
        userAuthId: string;
        userGuid: string;
        pageNum: number;
        pageSize: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/group/risk/user/detaial`,
                    params: parmas,
                },
                options
            )
        );
        return result;
    }
    // 部门知识库提交移除权限接口
    async getDepartmentBatchRemovePermission({
        ids,
        userGuids,
        groupGuid,
        taskId,
    }: {
        ids: string[];
        userGuids: string[];
        groupGuid: string;
        taskId: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/group/risk/handle/user`,
                    data: {
                        ids: ids,
                        userGuids: userGuids,
                        taskId: taskId,
                    },
                    params: {
                        groupGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 部门知识库提交移除权限接口进度获取
    async getDepartmentBatchRemovePermissionProcess(groupGuid: string, taskId: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/group/risk/detail/progress`,
                    params: {
                        taskId,
                        groupGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    // 组织权限处理修改状态
    async powerUpdateResolveStatus(parmas: {
            groupGuid: string;
            paramId: number;
        }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'put',
                    url: `${ServerConfig.ku}/group/risk/info`,
                    params: parmas,
                },
                options
            )
        );
        return result;
    }

    // 获取离职成员数据
    async getPowerMemberNameList(parmas:{
                groupGuid: string;
                historyId?: string;
                startDate?: number;
                endDate?: number;
        }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/group/risk/detail/users`,
                    params: parmas,
                },
                options
            )
        );
        return result;
    }
    async giveRepositoryAuthRiskNum(repositoryGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/repository/risk/tips`,
                    params: {
                        repositoryGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    async giveRepositoryAuthRiskLog(params:{
        repositoryGuid: string;
        pageNum: number;
        pageSize: number;
        userGuid: string;
        readStatus?: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/repository/risk/info/page`,
                    params: params,
                },
                options
            )
        );
        return result;
    }
    async updateRepositoryAuthRiskStatus(params:{
        repositoryGuid: string;
        riskId: number;
        readStatus: number;
        operateResult?: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/repository/risk/info/updateStatus`,
                    data: params,
                },
                options
            )
        );
        return result;
    }
    async getRepositoryAuthRiskUserList(params:{
        repositoryGuid: string;
        riskId: number;
        startDate: string;
        endDate: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/repository/risk/auth/user/all`,
                    params: params,
                },
                options
            )
        );
        return result;
    }
    async getRepositoryAuthRiskPersonnelList(params:{
        repositoryGuid: string;
        riskId: number;
        startDate: string;
        endDate: string;
        pageSize: number;
        pageNum: number;
        userGuid: string;
        objectType: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/repository/risk/auth/user/page`,
                    params: params,
                },
                options
            )
        );
        return result;
    }

    async getRepositoryAuthRiskPersonnelRepoBookList(params:{
        pageNum: number;
        pageSize: number;
        userGuid: string;
        userAuthId: number;
        repositoryGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/repository/risk/auth/user/detail`,
                    params: params,
                },
                options
            )
        );
        return result;
    }

    async getRepositoryBatchRemoveAuth(params:{
        taskId: string;
        repositoryGuid: string;
        ids?: number[];
        userGuid?: string;
        selectAll?: boolean;
        startDate?: string;
        endDate?: string;
        userGuidList?: string[];
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/repository/risk/auth/user/batchHandler`,
                    data: params,
                },
                options
            )
        );
        return result;
    }

    async getRepositoryBatchRemoveAuthProcess(params:{
        taskId: string;
        repositoryGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/repository/risk/auth/user/process`,
                    params: params,
                },
                options
            )
        );
        return result;
    }

    async getRepositoryAuthRiskSummary(repositoryGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/repository/risk/auth/user/summary`,
                    params: {repositoryGuid},
                },
                options
            )
        );
        return result;
    }

    // 快捷访问添加支持搜索，链接识别
    async getLinkRecognition(url: string, userGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/util/homepage/support`,
                    data: {
                        userGuid: userGuid,
                        url: url,
                    },
                },
                options
            )
        );
        return result;
    }
    // 查询用户拉新活动信息
    async getUserActiveStatus() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/coin/recruit/userInfo`,
                },
                options
            )
        );
        return result;
    }

    // 记录当前用户进入活动页信息
    async recordEnterActivityInfo(inviteCode: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/coin/recruit/recordInvitation`,
                    data: {
                        inviteCode,
                    },
                },
                options
            )
        );
        return result;
    }


    // 未渗透用户推荐投币文档列表
    async getCoinRecommendList() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/coin/recruit/recommendDoc`,
                },
                options
            )
        );
        console.log(result, 'result1111111111');
        return result;
    }

    // 查询推荐邀请的未渗透用户列表
    async getInviteUserList() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/coin/recruit/recommendInvitee`,
                },
                options
            )
        );
        return result;
    }

    // 邀请活动分享卡片
    async activeShareCard(
        shareMembers: Array<{avatar: string, gid: string, name: string}>
    ) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/coin/recruit/shares`,
                    data: {
                        shareMembers,
                    },
                },
                options
            )
        );
        return result;
    }


    async getIntimateCoinDocList() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/discovery/intimate/coinDocList`,
                },
                options
            )
        );
        return result;
    }

    // 个人主页-他人互动信息
    async getInteractionList(personalHomeUserGuid: string | undefined) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/interaction/user/list`,
                    params: {
                        userGuid: personalHomeUserGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    // 个人主页-他人发布动态
    async getOtherPublish(switchPage:boolean) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/personal/homepage/publish/trends/list`,
                    params: {
                        switchPage,
                    },
                },
                options
            )
        );
        return result;
    }

    // 公开文档敏感信息检测 查看明细
    async getSensitiveInfo(params: {
        repositoryGuid: string;
        riskId: number;
        page: number;
        pageSize: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/repository/risk/info/details`,
                    params: params,
                },
                options
            )
        );
        return result;
    }

    // 公开文档敏感信息检测 查看明细
    async getOvertimeCoinInfo() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/user/coin/exchange/info`,
                },
                options
            )
        );
        return result;
    }

    // 获取引用文档数
    async getImpowerDoc(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/cite/count`,
                    params: {
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 获取引用文档列表
    async getImpowerDocList(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/cite/permission/info`,
                    params: {
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    // 获取引用文档列表
    async addImpowerDocPower(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/doc/cite/permission/onclick`,
                    data: data,
                },
                options
            )
        );
        return result;
    }
    // async uploadSdkLog(data: {
    //         methodName: string;
    //         appId: string;
    //         docGuid: string;
    //         data: any;
    // }) {
    //     const options = this.requestOptions;
    //     const result = await this.request(
    //         Object.assign(
    //             {
    //                 method: 'post',
    //                 url: `${ServerConfig.ku}/doc/relation/add`,
    //                 data: {
    //                     bizGuid: uuid(),
    //                     bizType: 'docSdk',
    //                     docGuid: data.docGuid,
    //                     url: document.referrer,
    //                     bizData: data,
    //                     relationType: 'access',
    //                 },
    //             },
    //             options
    //         )
    //     );
    //     return result;
    // }
}

export const accountServerObj = new AccountServer();

export default AccountServer;
